import axios from 'axios';
import { apis } from 'service';

// export const COMMON_URL = `http://127.0.0.1:5000/presfor/`;
export const COMMON_URL = `https://api.presfor.digital.cgeds.com/presfor/`;


export const BASE_URL = `https://api.service.digital.cgeds.com/`;
//export const BASE_URL = `http://127.0.0.1:5000/`

export const REDASH_COMMON_URL = 'https://redash.cgeds.com/';
const GEOMATIC_URL = `https://pamofor.goazimut.com/api/`;
const GEOMATIC_TOKEN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MjcyMzY4MDAsInVzZXJuYW1lIjoiZ2xvYmFsZXhwZXJ0aXNlIiwic2VydmljZXMiOltdLCJpYXQiOjE2OTU2NjgyMTB9.H0KmSPbt8xqOfwgvpolKMbgHh06TyqGR1uM8ndLT9qs`;

const API_URLS = {
  UPDATE_ANNONCE_PUB: `${COMMON_URL}certificat-foncier/update-anp`,
  LIST_PUB: `${COMMON_URL}certificat-foncier/anp-by-enquete`,
  LIST_PUB_UNIQUE: `${COMMON_URL}certificat-foncier/anp`,
  GENERATE_CONTRAT: `${COMMON_URL}contrat/generate-contrat-pdf`,
  ADD_SERVITUDE: `${COMMON_URL}pvrdc/servitude`,
  ADD_ETAT_DE_DROIT: `${COMMON_URL}pvrdc/etat-droit`,
  UPDATE_ETAT_DE_DROIT: `${COMMON_URL}pvrdc/update-etat-droit`,
  DELETE_VALID: `${COMMON_URL}constat/delete-valid`,
  DELETE_CECPDC: `${COMMON_URL}constat/delete-cecpdc`,
  DELETE_ANP: `${COMMON_URL}certificat-foncier/delete-anp`,
  DELETE_ANPC: `${COMMON_URL}certificat-foncier/delete-anpc`,
  DELETE_ANPO: `${COMMON_URL}certificat-foncier/delete-anpo`,
  DELETE_CLP: `${COMMON_URL}clp/delete`,
  DELETE_PVCL: `${COMMON_URL}pvcl/delete`,
  DELETE_DCF: `${COMMON_URL}certificat-foncier/delete-dcf`,
  TRANSMISSION_DCF: `${COMMON_URL}certificat-foncier/dcf-transmission-byNNNNN`,
  TRANSMISSION_DCF_ENQUETE: `${COMMON_URL}certificat-foncier/dcf-transmission-byVillage`,
  DELETE_CF: `${COMMON_URL}certificat-foncier/delete-cf19`,
  GET_NUM_CONTRAT_ENQUETE: `${COMMON_URL}contrat/numero-contrats/by-enquete`,
  UPDATE_PVCL: `${COMMON_URL}pvcl/update-pvcl`,
  DELETE_ANNEXES_PVCL: `${COMMON_URL}pvcl/delete-lppc`,
  UPDATE_ANNEXES_PVCL: `${COMMON_URL}pvcl/update-lppc`,
  GET_PARCELLE_GEOMATIC: `${GEOMATIC_URL}parcelle`,
  UPDATE_DEMANDE_CF: `${COMMON_URL}certificat-foncier/update-certificat`,
  POST_PDF_CLP: `${COMMON_URL}clp/upload-clp-pdf`,
  GET_CLP: `${COMMON_URL}clp/find-one`,
  POST_ANNEXES_CLP: `${COMMON_URL}clp/clp-lppc`,
  POST_CLP: `${COMMON_URL}clp/new`,
  GET_ALL_NUM_DCF: `${COMMON_URL}certificat-foncier/get-all-nnnnn`,
  GET_PPD_SHP: `${COMMON_URL}certificat-foncier/download-shapeppd`,
  GET_PPP_SHP: `${COMMON_URL}certificat-foncier/download-shapeppp`,
  GET_PPD_PDF: `${COMMON_URL}certificat-foncier/ppdef/download-pdf`,
  GET_PPP_PDF: `${COMMON_URL}certificat-foncier/ppprov/download-pdf`,
  UPDATE_INFO_CF: `${COMMON_URL}certificat-foncier/refresh-de-cf`,
  UPDATE_STATUS_DEMANDE: `${COMMON_URL}certificat-foncier/refresh-anonce-pub-demandeur`,
  UPDATE_ETAT_DEMANDE: `${COMMON_URL}certificat-foncier/refresh-etat-dcf`,
  POST_PDF_CF: `${COMMON_URL}certificat-foncier/upload-cf`,
  POST_DEMANDES_PUB: `${COMMON_URL}certificat-foncier/anpd`,
  PDF_DEMANDES_PUB: `${COMMON_URL}certificat-foncier/create-anp-pdf`,
  POST_CLOTURE_PUB: `${COMMON_URL}certificat-foncier/anpc`,
  UPDATE_PV_CLOTURE_PUB: `${COMMON_URL}certificat-foncier/update-anpc`,
  ANNONCE_PUB: `${COMMON_URL}certificat-foncier/anp`,
  POST_PDF_PVO: `${COMMON_URL}certificat-foncier/upload-pvo`,
  POST_PVO_PRESENCE: `${COMMON_URL}certificat-foncier/dcf-pvo-lp`,
  POST_PVO: `${COMMON_URL}certificat-foncier/dcf-pvo`,
  POST_ANPO: `${COMMON_URL}certificat-foncier/anpo`,
  UPDATE_ANPO: `${COMMON_URL}certificat-foncier/update-anpo`,
  READ_PDF_CF: `${COMMON_URL}certificat-foncier/read-file`,
  POST_PDF_CONSTAT: `${COMMON_URL}constat/upload-constat-pdf`,
  GET_CONSTAT: `${COMMON_URL}constat/find-one`,
  POST_ANNEXES_CONSTAT: `${COMMON_URL}constat/add-person`,
  POST_CONSTAT: `${COMMON_URL}constat/new`,
  POST_PDF_CLOTUREPUB: `${COMMON_URL}certificat-foncier/upload-anpc`,
  POST_PDF_OUVERTUREPUB: `${COMMON_URL}certificat-foncier/upload-anpo`,
  CREATE_CLOTUREPUB_PUB: `${COMMON_URL}certificat-foncier/create-anpc-pdf`,
  POST_PDF_PUB: `${COMMON_URL}certificat-foncier/upload-anp`,
  POST_PDF_PVCL: `${COMMON_URL}pvcl/upload-pvcl-pdf`,
  GET_PVCL: `${COMMON_URL}pvcl/find-one`,
  POST_ANNEXES_PVCL: `${COMMON_URL}pvcl/lppc`,
  POST_PVCL: `${COMMON_URL}pvcl/new`,
  ADD_LISTE_SERVITUDE: `${COMMON_URL}pvrdc/servitude`,
  POST_PVRDC: `${COMMON_URL}pvrdc/new`,
  UPDATE_PVRDC: `${COMMON_URL}pvrdc/update`,
  ADD_MEMBRE_EQUIPE_ENQ_PVRDC: `${COMMON_URL}pvrdc/equipe-enquete`,
  UPDATE_MEMBRE_EQUIPE_ENQ_PVRDC: `${COMMON_URL}pvrdc/update/equipe-enquete`,
  DELETE_MEMBRE_EQUIPE_ENQ_PVRDC: `${COMMON_URL}pvrdc/delete/equipe-enquete`,
  POST_FICHE_DEMO_PVRDC: `${COMMON_URL}pvrdc/fiche-demographique`,
  ADD_DECLARATION_PVRDC: `${COMMON_URL}pvrdc/declaration`,
  UPDATE_DECLARATION_PVRDC: `${COMMON_URL}pvrdc/update/declaration`,
  DELETE_DECLARATION_PVRDC: `${COMMON_URL}pvrdc/delete/declaration`,
  ADD_LITIGE_PVRDC: `${COMMON_URL}pvrdc/fiche-identification-litige`,
  ADD_FICHE_LITIGE_PVRDC: `${COMMON_URL}pvrdc/fiche-litige`,
  UPDATE_FICHE_LITIGE_PVRDC: `${COMMON_URL}pvrdc/fiche-litige`,
  ADD_OCCUPANT_PARCELLE: `${COMMON_URL}pvrdc/add-dec-occupant`,
  DELETE_OCCUPANT_PARCELLE: `${COMMON_URL}pvrdc/delete-dec-occupant`,
  UPDATE_OCCUPANT_PARCELLE: `${COMMON_URL}pvrdc/update-dec-occupant`,
  UPDATE_OCCUP_PARCELLE_DATE: `${COMMON_URL}pvrdc/occupant-parcelle`,
  ADD_OCCUP_PARCELLE_DATE: `${COMMON_URL}pvrdc/occupant-parcelle`,
  ADD_ETAT_DE_DROIT_PROP: `${COMMON_URL}pvrdc/add-etat-droit`,
  DELETE_PVRDC_FICHE_DEMOGRAPHIQUE: `${COMMON_URL}pvrdc/annexe/remove-fiche-demo`,
  DELETE_PVRDC_ANNEXE_EQUIPE_ENQUETE: `${COMMON_URL}pvrdc/annexe/remove-equipe-enquete`,
  DELETE_PVRDC_ANNEXE_DECLARATION_OCCUPANT: `${COMMON_URL}pvrdc/annexe/remove-declaration-persone-auditionne`,
  DELETE_PVRDC_ANNEXE_OCCUPANT_PARCELLE: `${COMMON_URL}pvrdc/annexe/remove-occupant-personne`,
  DELETE_PVRDC_ANNEXE_FICHE_LITIGE: `${COMMON_URL}pvrdc/annexe/remove-fiche-litige`,
  DELETE_PVRDC_ANNEXE_DESIGNATION_GESTIONNAIRE: `${COMMON_URL}pvrdc/annexe/remove-designation-gestionnaire`,
  DELETE_PVRDC_ANNEXE_DETENTEUR_DROIT: `${COMMON_URL}pvrdc/annexe/remove-detenteur-droit`,
  DELETE_PVRDC_ANNEXE_ETAT_DROIT: `${COMMON_URL}pvrdc/annexe/remove-etat-droit`,
  DELETE_PVRDC: `${COMMON_URL}pvrdc/remove-pvrdc`,
  DELETE_PVRDC_ANNEXE_SERVITUDE: `${COMMON_URL}pvrdc/annexe/remove-annexe-servitude`,
  DELETE_PVRDC_ANNEXE_SIGNATURE_DESIGNATION_GESTIONNAIRE: `${COMMON_URL}pvrdc/annexe/remove-signature-designation-gestionnaire`,
  ADD_AYANT_DROIT: `${COMMON_URL}pvrdc/ayant-droit`,
  POST_PDF_PVRDC: `${COMMON_URL}pvrdc/upload-pvrdc-pdf`,
  GET_CF: `${COMMON_URL}certificat-foncier/dcf-one`,
  GET_PVRDC: `${COMMON_URL}certificat-foncier/pvrdc-by-dcf`,
  GET_DCF_CONSTATS: `${COMMON_URL}constat/dcf-constats`,
  GET_DCF_ANNONCE_PUBLICITE: `${COMMON_URL}certificat-foncier/annoncepub-by-certif`,
  POST_PDF_CFPIECE: `${COMMON_URL}certificat-foncier/upload-dcf-piece`,
  POST_PDF_CFPIECE_CLIENT: `${COMMON_URL}certificat-foncier/upload-dcf-client-piece`,
  UPDATE_PDF_CFPIECE: `${COMMON_URL}certificat-foncier/update-dcf-piece`,
  POST_PDF_DCF: `${COMMON_URL}certificat-foncier/upload-dcf-pdf`,
  POST_DEMANDE_CF: `${COMMON_URL}certificat-foncier/new`,
  POST_DESIGNATION_GESTIONNAIRECFC: `${COMMON_URL}pvrdc/add-gbfc`,
  PUT_DESIGNATION_GESTIONNAIRECFC: `${COMMON_URL}pvrdc/update-gbfc`,
  POST_DCF_DEMANDE_CLIENT: `${COMMON_URL}certificat-foncier/client/new-dcf`,
  ADD_SIGNATAIRE_BIEN_FONCIER: `${COMMON_URL}pvrdc/add-liste-gbfc`,
  ADD_DETENTEURS_DE_DROITS_CF: `${COMMON_URL}pvrdc/listeddcc`,
  LOG_ACTIVITY: `${COMMON_URL}log-activity/getLogsBy`,
  GET_CF_BY_ENQ: `${COMMON_URL}certificat-foncier/by-enquete`,
  POST_TEMOIN_CONTRAT: `${COMMON_URL}contrat/add-temoin`,
  UPDATE_TEMOIN_CONTRAT: `${COMMON_URL}contrat/update-temoin`,
  POST_PDF_CONTRAT: `${COMMON_URL}contrat/upload-contract`,
  POST_CECPDC_PDF: `${COMMON_URL}constat/generate-cecpdc-pdf`,
  POST_VALID_PDF: `${COMMON_URL}constat/generate-valid-pdf`,
  UPDATE_PROCURATION_CONTRAT: `${COMMON_URL}update/procuration`,
  POST_PDF_CNI_CONTRAT: `${COMMON_URL}contrat/file-pieces`,
  POST_FICHE_IDENTIFICATION: `${COMMON_URL}certificat-foncier/fiche-identification`,
  UPDATE_FICHE_IDENTIFICATION: `${COMMON_URL}certificat-foncier/fiche-identification`,
  UPDATE_PDF_CNI_CONTRAT: `${COMMON_URL}update/file-pieces`,
  POST_PDF_PROCURATION_CONTRAT: `${COMMON_URL}contrat/upload-procuration`,
  UPDATE_PDF_PROCURATION_CONTRAT: `${COMMON_URL}update/file-pieces`,
  POST_PDF_CROQUIS_CONTRAT: `${COMMON_URL}contrat/upload-croquis`,
  POST_ANNEXES_CONTRAT: `${COMMON_URL}contrat/upload-annexe`,
  UPDATE_ANNEXES_CONTRAT: `${COMMON_URL}update/annexe`,
  UPDATE_ANNEXES_CROQUIS: `${COMMON_URL}update/croquis`,
  READ_PDF_PROCURATION: `${COMMON_URL}contrat-read/procuration`,
  READ_PDF_CROQUIS: `${COMMON_URL}contrat-read/croquis`,
  READ_PDF_CONTRAT: `${COMMON_URL}read-contract/file`,
  READ_PDF_ANNEXES: `${COMMON_URL}contrat-read/annexe/`,
  READ_PDF_PIECESID: `${COMMON_URL}contrat-read/piece/`,
  GET_CONTRAT_ENQ: `${COMMON_URL}contrat/by-enquete`,
  GET_CONTRAT: `${COMMON_URL}contrat/findone`,
  GET_CONTRAT_ALL: `${COMMON_URL}contrat/all`,
  GET_DELETE_CONTRAT: `${COMMON_URL}update/delete/`,
  POST_SOUSSIGNE_CONTRAT: `${COMMON_URL}contrat/add-person`,
  PUT_SOUSSIGNE_CONTRAT: `${COMMON_URL}contrat/update-person`,
  POST_CONTRAT: `${COMMON_URL}contrat/new`,
  UPDATE_CONTRAT: `${COMMON_URL}contrat/update-contrat`,
  GET_ENQUETE_USER: `${COMMON_URL}enquete/by-user`,
  GET_ENQUETE_ALL: `${COMMON_URL}enquete/all`,
  GET_ONLY_ENQUETE_ALL: `${COMMON_URL}enquete/all-enquete`,
  GET_ONLY_ENQUETE_ALL_CLIENT: `${COMMON_URL}enquete/check-enquete`,
  POST_ENQUETE_CLIENT: `${COMMON_URL}enquete/new-client-enquete`,
  GET_COMMUNE_VIL: `${COMMON_URL}codification/commune-vil`,
  GET_SP_COMMUNE: `${COMMON_URL}codification/sp-commune`,
  GET_DEP_SP: `${COMMON_URL}codification/dep-sp`,
  GET_REGION_DEP: `${COMMON_URL}codification/region-dep`,
  GET_REGIONS: `${COMMON_URL}codification/regions`,
  POST_USER_RESEND_EMAIL: `${COMMON_URL}user/resend-email`,
  POST_USER_CONFIRM_EMAIL: `${COMMON_URL}user/confirm-email`,
  CHANGE_PSWD_USER: `${COMMON_URL}user/change-password`,
  FORGOT_PSWD_USER: `${COMMON_URL}user/forgot-password`,
  SIGNIN_USER: `${COMMON_URL}user/signin`,
  UPDATE_USER: `${COMMON_URL}user`,
  REFRESH_TOKEN_USER: `${COMMON_URL}user/refresh-token`,
  SIGNUP_USER: `${COMMON_URL}user/signup`,
  GET_ALL_USER: `${COMMON_URL}user/all`,
  GET_CHECK_USER: `${COMMON_URL}user/check-admin`,
  POST_ENQUETE: `${COMMON_URL}enquete/new`,
  GET_ENQUETE_BY_CODE: `${COMMON_URL}enquete/by-code`,
  GET_ALL_CF: `${COMMON_URL}certificat-foncier/cf/all`,
  GET_ALL_DCF: `${COMMON_URL}certificat-foncier/list-dcf`,
  ADD_OTA: `${COMMON_URL}ota/create-ota`,
  GET_ALL_OTA: `${COMMON_URL}ota/all`,
  GET_ALL_DCF_CLIENT: `${COMMON_URL}certificat-foncier/all-dcf`,
  GET_ONE_OTA: `${COMMON_URL}ota`,
  POST_DECLARATION_OUVERTURE: `${COMMON_URL}clarification/declaration-ouverture/new`,
  POST_TRANSMISSION_LETTRE: `${COMMON_URL}clarification/transmission-lettre/new`,
  UPDATE_DECLARATION_OUVERTURE: `${COMMON_URL}clarification/declaration-ouverture/update`,
  UPDATE_TRANSMISSION_LETTRE: `${COMMON_URL}clarification/transmission-lettre/update`,
  DELETE_DO: `${COMMON_URL}clarification/declaration-ouverture/delete`,
  DELETE_TL: `${COMMON_URL}clarification/transmission-lettre/delete`,
  GET_TL: `${COMMON_URL}clarification/transmission-by-code`,
  POST_AEFC: `${COMMON_URL}consolidation/new/attestation-aefc`,
  POST_AEFJ: `${COMMON_URL}consolidation/new/attestation-aefj`,
  DOWNLOAD_MOBILE_APP: `${COMMON_URL}certificat-foncier/download-apk`,
  SEND_MESSAGE: `${COMMON_URL}contact/send-message`,
  //PUT_DESIGNATION_GESTIONNAIRECFC: `${COMMON_URL}pvrdc/update-gbfc`,
  // CREATE_DCF_ANP_PDFS: `${COMMON_URL}certificat-foncier/create-dcf-anp-pdf`
  GET_VILLAGES_BY_CODE_ENQUETE: `${COMMON_URL}codification/sp`,
  GET_DTV_BY_ENQUETE: `${COMMON_URL}dtv/by-enquete`,
  POST_ATTESTATION_VALIDATION_ENQUETE: `${COMMON_URL}dtv/attestation-valid`,
  PUT_ATTESTATION_VALIDATION_ENQUETE: `${COMMON_URL}dtv/attestation-valid`,
  GET_PARTICIPANTS_ATTESTATION_VALIDATION_ENQUETE_RURAL: `${COMMON_URL}dtv/participants-attestation-validation-rural`,
  POST_ATTESTATION_APPROBATION_ENQUETE: `${COMMON_URL}dtv/attestation-approbation`,
  PUT_ATTESTATION_APPROBATION_ENQUETE: `${COMMON_URL}dtv/attestation-approbation`,
  POST_DTV_HISTO: `${COMMON_URL}dtv/histo`,
  GET_TRONCONS: `${COMMON_URL}dtv/pvlim`,
  POST_TRONCON: `${COMMON_URL}dtv/pvlim`,
  PUT_TRONCON: `${COMMON_URL}dtv/pvlim`,
  POST_DTV_ANP: `${COMMON_URL}dtv/anp`,
  PUT_DTV_ANP: `${COMMON_URL}dtv/anp`,
  POST_DTV_ANPO: `${COMMON_URL}dtv/anpo`,
  PUT_DTV_ANPO: `${COMMON_URL}dtv/anpo`,

  POST_ANPC: `${COMMON_URL}dtv/anpc`,
  DELETE_TRONCON: `${COMMON_URL}dtv/pvlim`,
  UPLOAD_PVLIM: `${COMMON_URL}dtv/upload-pvlim-pdf`,
  DELETE_TRONCON_ALL: `${COMMON_URL}dtv/remove-enquete-pvlim`,
  DELETE_PV_HISTO: `${COMMON_URL}dtv/histo`,
  POST_HISTO_PIECE: `${COMMON_URL}dtv/upload-histo-pdf`,

  DELETE_DTV_ANP: `${COMMON_URL}dtv/anp`,
  DELETE_DTV_ANPO: `${COMMON_URL}dtv/anpo`,

  POST_ANP_PIECE: `${COMMON_URL}dtv/upload-anp-pdf`,
  POST_ANPO_PIECE: `${COMMON_URL}dtv/upload-anpo-pdf`,

  GET_ANP_BY_ENQUETE: `${COMMON_URL}dtv/anp-by-enquete`,
  UPDATE_DTV_ANPC: `${COMMON_URL}dtv/anpc`,

  DELETE_DTV_ANPC: `${COMMON_URL}dtv/anpc`,
  DELETE_ATTESTATION_APPROBATION_ENQUETE: `${COMMON_URL}dtv/attestation-approb`,
  DELETE_ATTESTATION_VALIDATION_ENQUETE: `${COMMON_URL}dtv/attestation-valid`,

  UPLOAD_DTV_ANPC: `${COMMON_URL}dtv/upload-anpc-pdf`,
  UPLOAD_ATTESTATION_APPROBATION_ENQUETE: `${COMMON_URL}dtv/upload-approb-pdf`,
  UPLOAD_ATTESTATION_VALIDATION_ENQUETE: `${COMMON_URL}dtv/upload-valid-pdf`,

  GENERER_PDF_CONSTAT_LIMITE_TRONCON: `${COMMON_URL}dtv/generate-pvlim-pdf`,

  GET_CALENDRIER_OUVERTURE: `${COMMON_URL}isf/calendrier-ouverture`,
  POST_CALENDRIER_OUVERTURE: `${COMMON_URL}isf/calendrier-ouverture`,
  PUT_CALENDRIER_OUVERTURE: `${COMMON_URL}isf/calendrier-ouverture`,
  DELETE_CALENDRIER_OUVERTURE: `${COMMON_URL}isf/delete-calendrier-ouverture`,

  UPLOAD_CALENDRIER_OUVERTURE: `${COMMON_URL}isf/upload-calendrier-ouverture-pdf`,
  GENERER_PDF_CALENDRIER_OUVERTURE: `${COMMON_URL}isf/calendrier-ouverture`,

  GET_LISTE_PRESENCE_CONTACT: `${COMMON_URL}prise-contact/prise-contact`,
  POST_LISTE_PRESENCE_CONTACT: `${COMMON_URL}prise-contact/prise-contact`,
  PUT_LISTE_PRESENCE_CONTACT: `${COMMON_URL}prise-contact/prise-contact`,
  DELETE_LISTE_PRESENCE_CONTACT: `${COMMON_URL}prise-contact/delete-prise-contact`,

  UPLOAD_LISTE_PRESENCE_CONTACT: `${COMMON_URL}prise-contact/upload-prise-contact-pdf`,
  GENERER_PDF_LISTE_PRESENCE_CONTACT: `${COMMON_URL}prise-contact`,

  GET_COMPTE_RENDU_CONTACT: `${COMMON_URL}prise-contact/compte-rendu`,
  POST_COMPTE_RENDU_CONTACT: `${COMMON_URL}prise-contact/compte-rendu`,
  PUT_COMPTE_RENDU_CONTACT: `${COMMON_URL}prise-contact/compte-rendu`,
  DELETE_COMPTE_RENDU_CONTACT: `${COMMON_URL}prise-contact/delete-compte-rendu`,

  UPLOAD_COMPTE_RENDU_CONTACT: `${COMMON_URL}prise-contact/upload-compte-rendu-pdf`,
  GENERER_PDF_COMPTE_RENDU_CONTACT: `${COMMON_URL}prise-contact`,

  POST_PVCFIDCP: `${COMMON_URL}dialogue-social/pvcfi-dcp`,
  PUT_PVCFIDCP: `${COMMON_URL}dialogue-social/pvcfi-dcp`,
  DELETE_PVCFIDCP: `${COMMON_URL}dialogue-social/pvcfi-dcp`,

  UPLOAD_PDF_PVCFIDCP: `${COMMON_URL}dialogue-social/pvcfi-dcp`,
  GENERER_PDF_PVCFIDCP: `${COMMON_URL}dialogue-social/pvcfi-dcp`,

  POST_PVCFIDCI: `${COMMON_URL}dialogue-social/pvcfi-dci`,
  PUT_PVCFIDCI: `${COMMON_URL}dialogue-social/pvcfi-dci`,
  DELETE_PVCFIDCI: `${COMMON_URL}dialogue-social/pvcfi-dci`,

  UPLOAD_PDF_PVCFIDCI: `${COMMON_URL}dialogue-social/pvcfi-dci`,
  GENERER_PDF_PVCFIDCI: `${COMMON_URL}dialogue-social/pvcfi-dci`,

  POST_PVCFIDCC: `${COMMON_URL}dialogue-social/pvcfi-dcc`,
  PUT_PVCFIDCC: `${COMMON_URL}dialogue-social/pvcfi-dcc`,
  DELETE_PVCFIDCC: `${COMMON_URL}dialogue-social/pvcfi-dcc`,

  UPLOAD_PDF_PVCFIDCC: `${COMMON_URL}dialogue-social/pvcfi-dcc`,
  GENERER_PDF_PVCFIDCC: `${COMMON_URL}dialogue-social/pvcfi-dcc`,

  GET_DIALOGUE_SOCIAL: `${COMMON_URL}dialogue-social/pvcfi`,
  DELETE_PVCFIDC: `${COMMON_URL}dialogue-social/pvcfi`,
  UPLOAD_PDF_PVCFIDC: `${COMMON_URL}dialogue-social/upload-pvcfi-pdf`,

  POST_CHARTERELATION: `${COMMON_URL}charte/new`,
  GET_CHARTERELATION: `${COMMON_URL}charte`,
  PUT_CHARTERELATION: `${COMMON_URL}charte`,
  DELETE_CHARTERELATION: `${COMMON_URL}charte`,
  UPLOADS_CHARTE_PDF: `${COMMON_URL}charte/upload-charte-pdf`,

  // Protocole de gestion foncière (PGF)
  GET_PGF_BY_NUMERO: `${COMMON_URL}dialogue-social/pgf`,
  POST_NEW_PGF: `${COMMON_URL}dialogue-social/pgf/new`,
  PUT_UPDATE_PGF: `${COMMON_URL}dialogue-social/pgf`,
  DELETE_PGF: `${COMMON_URL}dialogue-social/delete-pgf`,
  POST_UPLOAD_PGF_PDF: `${COMMON_URL}dialogue-social/upload-pgf-pdf`,

  // GET_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE: `${COMMON_URL}reunion-periodique/decision-designation-activite`,

  POST_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE: `${COMMON_URL}reunion-periodique/decision-designation-activite`,
  PUT_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE: `${COMMON_URL}reunion-periodique/decision-designation-activite`,
  DELETE_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE: `${COMMON_URL}reunion-periodique/delete-decision-designation-activite`,

  UPLOAD_PDF_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE: `${COMMON_URL}reunion-periodique/upload-decision-pdf`,
  GENERER_PDF_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE: `${COMMON_URL}reunion-periodique/decision-designation-activite`,

  GET_REUNION_PERIODIQUE: `${COMMON_URL}reunion-periodique`,

  // GET_REUNION_PERIODIQUE: `${COMMON_URL}reunion-periodique/resume-resolution`,
  POST_REUNION_PERIODIQUE_RESUME: `${COMMON_URL}reunion-periodique/resume-resolution`,
  PUT_REUNION_PERIODIQUE_RESUME: `${COMMON_URL}reunion-periodique/resume-resolution`,
  DELETE_REUNION_PERIODIQUE_RESUME: `${COMMON_URL}reunion-periodique/delete-resume-resolution`,

  UPLOAD_PDF_REUNION_PERIODIQUE_RESUME: `${COMMON_URL}reunion-periodique/upload-resume-pdf`,
  GENERER_PDF_REUNION_PERIODIQUE_RESUME: `${COMMON_URL}reunion-periodique/resume-resolution`,

  POST_DECISION_ISF_CVGFR: `${COMMON_URL}diagnostic/decision-creation-cvgfr`,
  GET_DECISION_ISF_CVGFR: `${COMMON_URL}diagnostic/decision-creation-cvgfr`,
  PUT_DECISION_ISF_CVGFR: `${COMMON_URL}diagnostic/decision-creation-cvgfr`,
  DELETE_DECISION_ISF_CVGFR: `${COMMON_URL}diagnostic/delete-decision-creation-cvgfr`,

  UPLOAD_PDF_DECISION_ISF_CVGFR: `${COMMON_URL}diagnostic/decision-creation-cvgfr-pdf`,
  GENERER_PDF_DECISION_ISF_CVGFR: `${COMMON_URL}diagnostic/decision-creation-cvgfr`,

  POST_PV_CONSTITUTION_CVGFR: `${COMMON_URL}diagnostic/pv-constitution-cvgfr`,
  PUT_PV_CONSTITUTION_CVGFR: `${COMMON_URL}diagnostic/pv-constitution-cvgfr`,
  GET_PV_CONSTITUTION_CVGFR: `${COMMON_URL}diagnostic/pv-constitution-cvgfr`,
  DELETE_PV_CONSTITUTION_CVGFR: `${COMMON_URL}diagnostic/delete-pv-constitution`,

  UPLOAD_PDF_PV_CONSTITUTION_CVGFR: `${COMMON_URL}diagnostic/pv-constitution-cvgfr-pdf`,
  GENERER_PDF_PV_CONSTITUTION_CVGFR: `${COMMON_URL}diagnostic/pv-constitution-cvgfr`,

  POST_LIVRABLE_ISF_CVGFR: `${COMMON_URL}diagnostic/diagnostic-cvgfr`,
  GET_LIVRABLE_ISF_CVGFR: `${COMMON_URL}diagnostic/diagnostic-cvgfr`,
  PUT_LIVRABLE_ISF_CVGFR: `${COMMON_URL}diagnostic/diagnostic-cvgfr`,
  DELETE_LIVRABLE_ISF_CVGFR: `${COMMON_URL}diagnostic/delete-diagnostic-cvgfr`,
  UPDATE_LIVRABLE_ISF_CVGFR: `${COMMON_URL}diagnostic/diagnostic-cvgfr`,

  UPLOAD_PDF_LIVRABLE_ISF_CVGFR: `${COMMON_URL}diagnostic/upload-diagnostic-cvgfr-pdf`,
  GENERER_PDF_LIVRABLE_ISF_CVGFR: `${COMMON_URL}diagnostic/diagnostic-cvgfr`,

  POST_CACHIERS_INTENTIONS_CF: `${COMMON_URL}registre-intention/dcf`,
  GET_CACHIERS_INTENTIONS_CF: `${COMMON_URL}registre-intention/dcf`,
  PUT_CACHIERS_INTENTIONS_CF: `${COMMON_URL}registre-intention/dcf`,

  POST_CACHIERS_INTENTIONS_CONTRAT: `${COMMON_URL}registre-intention/dcc`,
  GET_CACHIERS_INTENTIONS_CONTRAT: `${COMMON_URL}registre-intention`,
  PUT_CACHIERS_INTENTIONS_CONTRAT: `${COMMON_URL}registre-intention/dcc`,

  GET_REGLEMENT_INTERIEUR_CVGFR: `${COMMON_URL}formation-cvgfr/reglement-interieur-cvgfr`,
  POST_REGLEMENT_INTERIEUR_CVGFR: `${COMMON_URL}formation-cvgfr/reglement-interieur-cvgfr`,
  PUT_REGLEMENT_INTERIEUR_CVGFR: `${COMMON_URL}formation-cvgfr/reglement-interieur-cvgfr`,
  DELETE_REGLEMENT_INTERIEUR_CVGFR: `${COMMON_URL}formation-cvgfr/reglement-interieur-cvgfr`,
  UPLOAD_PDF_REGLEMENT_INTERIEUR_CVGFR: `${COMMON_URL}formation-cvgfr/upload-reglement-interieur-cvgfr-pdf`,
  GENERER_PDF_REGLEMENT_INTERIEUR_CVGFR: `${COMMON_URL}formation-cvgfr/reglement-interieur-cvgfr`,

  GET_ATTESTATION_FORMATION_CVGFR: `${COMMON_URL}formation-cvgfr/attestation-formation-cvgfr`,
  POST_ATTESTATION_FORMATION_CVGFR: `${COMMON_URL}formation-cvgfr/attestation-formation-cvgfr`,
  PUT_ATTESTATION_FORMATION_CVGFR: `${COMMON_URL}formation-cvgfr/attestation-formation-cvgfr`,
  DELETE_ATTESTATION_FORMATION_CVGFR: `${COMMON_URL}formation-cvgfr/attestation-formation-cvgfr`,
  UPLOAD_PDF_ATTESTATION_FORMATION_CVGFR: `${COMMON_URL}formation-cvgfr/upload-attestation-formation-cvgfr-pdf`,
  GENERER_PDF_ATTESTATION_FORMATION_CVGFR: `${COMMON_URL}formation-cvgfr/attestation-formation-cvgfr`,

  GET_LISTE_PRESENCE_FORMATION_CVGFR: `${COMMON_URL}formation-cvgfr/attestation-formation-cvgfr`,
  POST_LISTE_PRESENCE_FORMATION_CVGFR: `${COMMON_URL}formation-cvgfr/liste-presence`,
  PUT_LISTE_PRESENCE_FORMATION_CVGFR: `${COMMON_URL}formation-cvgfr/liste-presence`,
  DELETE_LISTE_PRESENCE_FORMATION_CVGFR: `${COMMON_URL}formation-cvgfr/liste-presence`,
  UPLOAD_PDF_LISTE_PRESENCE_FORMATION_CVGFR: `${COMMON_URL}formation-cvgfr/upload-liste-presence-pdf`,
  GENERER_PDF_LISTE_PRESENCE_FORMATION_CVGFR: `${COMMON_URL}formation-cvgfr/liste-presence`,

  DELETE_CACHIERS_INTENTIONS_CF: `${COMMON_URL}registre-intention/delete-dcf`,
  DELETE_CACHIERS_INTENTIONS_CONTRAT: `${COMMON_URL}registre-intention/delete-dcc`,
  UPLOAD_PDF_CACHIERS_INTENTIONS_CF: `${COMMON_URL}registre-intention/upload-dcf-pdf`,
  UPLOAD_PDF_CACHIERS_INTENTIONS_CONTRAT: `${COMMON_URL}registre-intention/upload-dcc-pdf`,

  POST_ISF_DECLARATION_OUVERTURE: `${COMMON_URL}isf/declaration-ouverture`,
  PUT_ISF_DECLARATION_OUVERTURE: `${COMMON_URL}isf/declaration-ouverture`,
  DELETE_ISF_DECLARATION_OUVERTURE: `${COMMON_URL}isf/delete-declaration-ouverture`,
  UPLOAD_PDF_ISF_DECLARATION_OUVERTURE: `${COMMON_URL}isf/upload-declaration-ouverture-pdf`,
  GET_ISFR_DECLARATION_OUVERTURE: `${COMMON_URL}isf/declaration-ouverture`,

  POST_ISF_CEREMONIE_OUVERTURE: `${COMMON_URL}ceremonie-ouverture/ceremonie-ouverture`,
  PUT_ISF_CEREMONIE_OUVERTURE: `${COMMON_URL}ceremonie-ouverture/ceremonie-ouverture`,
  DELETE_ISF_CEREMONIE_OUVERTURE: `${COMMON_URL}ceremonie-ouverture/delete-co`,
  UPLOAD_PDF_ISF_CEREMONIE_OUVERTURE: `${COMMON_URL}ceremonie-ouverture/upload-co-pdf`,
  GET_ISFR_CEREMONIE_OUVERTURE: `${COMMON_URL}ceremonie-ouverture/ceremonie-ouverture`,

  POST_ISF_COMPTE_RENDU: `${COMMON_URL}ceremonie-ouverture/compte-rendu`,
  PUT_ISF_COMPTE_RENDU: `${COMMON_URL}ceremonie-ouverture/compte-rendu`,
  DELETE_ISF_COMPTE_RENDU: `${COMMON_URL}ceremonie-ouverture/delete-compte-rendu`,
  UPLOAD_PDF_ISF_COMPTE_RENDU: `${COMMON_URL}ceremonie-ouverture/upload-compte-rendu-pdf`,
  GET_ISF_COMPTE_RENDU: `${COMMON_URL}ceremonie-ouverture/compte-rendu`,

  POST_ISF_RAPPORT_VILLAGE: `${COMMON_URL}ceremonie-ouverture/rapport-isf`,
  PUT_ISF_RAPPORT_VILLAGE: `${COMMON_URL}ceremonie-ouverture/rapport-isf`,
  DELETE_ISF_RAPPORT_VILLAGE: `${COMMON_URL}ceremonie-ouverture/delete-rapport-isf`,
  UPLOAD_PDF_ISF_RAPPORT_VILLAGE: `${COMMON_URL}ceremonie-ouverture/upload-rapport-isf-pdf`,
  GET_ISF_RAPPORT_VILLAGE: `${COMMON_URL}ceremonie-ouverture/rapport-isf`,

  POST_ISF_CALENDRIER_PREV: `${COMMON_URL}elaboration-calendrier/calendrier-prev`,
  PUT_ISF_CALENDRIER_PREV: `${COMMON_URL}elaboration-calendrier/calendrier-prev`,
  DELETE_ISF_CALENDRIER_PREV: `${COMMON_URL}elaboration-calendrier/delete-calendrier-prev`,
  UPLOAD_PDF_ISF_CALENDRIER_PREV: `${COMMON_URL}elaboration-calendrier/upload-calendrier-prev-pdf`,
  GET_ISF_CALENDRIER_PREV: `${COMMON_URL}elaboration-calendrier/calendrier-prev`,

  POST_ISF_COURRIER_TRANS: `${COMMON_URL}elaboration-calendrier/courrier-trans`,
  PUT_ISF_COURRIER_TRANS: `${COMMON_URL}elaboration-calendrier/courrier-trans`,
  DELETE_ISF_COURRIER_TRANS: `${COMMON_URL}elaboration-calendrier/delete-courrier-trans`,
  UPLOAD_PDF_ISF_COURRIER_TRANS: `${COMMON_URL}elaboration-calendrier/upload-courrier-trans-pdf`,
  GET_ISF_COURRIER_TRANS: `${COMMON_URL}elaboration-calendrier/courrier-trans`,

  LOGIN_WITH_TOKEN: `${COMMON_URL}user/login-with-token`,
  GET_USER: `${COMMON_URL}user`,
  POST_CALENDRIER_PREVISIONEL: `${COMMON_URL}dialogue-social/calendrier-previsionel`,
  PUT_CALENDRIER_PREVISIONEL: `${COMMON_URL}dialogue-social/calendrier-previsionel`,
  GET_CALENDRIER_PREVISIONEL: `${COMMON_URL}dialogue-social/calendrier-previsionel`,
  UPLOAD_PDF_CALENDRIER_PREVISIONNEL: `${COMMON_URL}dialogue-social/upload-calendrier-previsionel-pdf`,
  DELETE_CALENDRIER_PREVSIONNEL: `${COMMON_URL}dialogue-social/calendrier-previsionel`,

  POST_PROCES_VERBAL_REGLEMENT_LITIGE: `${COMMON_URL}dialogue-social/pvrlf`,
  PUT_PROCES_VERBAL_REGLEMENT_LITIGE: `${COMMON_URL}dialogue-social/pvrlf`,
  DELETE_PROCES_VERBAL_REGLEMENT_LITIGE: `${COMMON_URL}dialogue-social/pvrlf`,
  UPLOAD_PDF_PROCES_VERBAL_REGLEMENT_LITIGE: `${COMMON_URL}dialogue-social/upload-pvrlf-pdf`,
  GET_PROCES_VERBAL_REGLEMENT_LITIGE: `${COMMON_URL}dialogue-social/pvrlf`,

  POST_ISF_DEMANDE_IDENTITE: `${COMMON_URL}activites-dialogue-social/new`,
  PUT_ISF_DEMANDE_IDENTITE: `${COMMON_URL}activites-dialogue-social`,
  DELETE_ISF_DEMANDE_IDENTITE: `${COMMON_URL}activites-dialogue-social/delete-demande-identite`,
  UPLOAD_PDF_ISF_DEMANDE_IDENTITE: `${COMMON_URL}activites-dialogue-social/upload-demande-identite-pdf`,
  GET_ISF_DEMANDE_IDENTITE: `${COMMON_URL}activites-dialogue-social`,

  POST_ISF_PROCES_VERBAL_ACHEVEMENT: `${COMMON_URL}dialogue-social/pvca/new`,
  PUT_PROCES_VERBAL_ACHEVEMENT: `${COMMON_URL}dialogue-social/pvca`,
  DELETE_PROCES_VERBAL_ACHEVEMENT: `${COMMON_URL}dialogue-social/delete-pvca`,
  UPLOAD_PDF_PROCES_VERBAL_ACHEVEMENT: `${COMMON_URL}dialogue-social/upload-pvca-pdf`,
  GET_PROCES_VERBAL_ACHEVEMENT: `${COMMON_URL}dialogue-social/pvca`,
  UPLOAD_PDF_ISF_PROCES_VERBAL_ACHEVEMENT: `${COMMON_URL}dialogue-social/upload-pvca-pdf`,

  POST_ISF_RAPPORT_ACTIVITE: `${COMMON_URL}rapport/activite`,
  PUT_ISF_RAPPORT_ACTIVITE: `${COMMON_URL}rapport/activite`,
  DELETE_ISF_RAPPORT_ACTIVITE: `${COMMON_URL}rapport/activite`,
  UPLOAD_PDF_ISF_RAPPORT_ACTIVITE: `${COMMON_URL}rapport/upload-activite-pdf`,
  GET_ISF_RAPPORT_ACTIVITE: `${COMMON_URL}rapport`,

  POST_ISF_GUIDE_ENTRETIEN: `${COMMON_URL}dialogue-social/guide-entretien`,
  PUT_GUIDE_ENTRETIEN: `${COMMON_URL}dialogue-social/guide-entretien`,
  DELETE_GUIDE_ENTRETIEN: `${COMMON_URL}dialogue-social/guide-entretien`,
  UPLOAD_PDF_GUIDE_ENTRETIEN: `${COMMON_URL}dialogue-social/guide-entretien`,
  GET_GUIDE_ENTRETIEN: `${COMMON_URL}dialogue-social/guide-entretien`,
  UPLOAD_PDF_ISF_GUIDE_ENTRETIEN: `${COMMON_URL}dialogue-social/upload-guide-entretien-pdf`,

  POST_ISF_RAPPORT_SENSIBILISATION_ISF: `${COMMON_URL}information-sensibilisation/is-rapport-isf`,
  PUT_RAPPORT_SENSIBILISATION_ISF: `${COMMON_URL}information-sensibilisation/is-rapport-isf`,
  DELETE_RAPPORT_SENSIBILISATION_ISF: `${COMMON_URL}information-sensibilisation/delete-rapport-isf`,
  GET_RAPPORT_SENSIBILISATION_ISF: `${COMMON_URL}information-sensibilisation/is-rapport-isf`,
  UPLOAD_PDF_ISF_RAPPORT_SENSIBILISATION_ISF: `${COMMON_URL}information-sensibilisation/upload-is-rapport-pdf`,

  POST_ISF_SENSIBILISATION: `${COMMON_URL}information-sensibilisation/information-sensibilisation`,
  PUT_ISF_SENSIBILISATION: `${COMMON_URL}information-sensibilisation/information-sensibilisation`,
  DELETE_ISF_SENSIBILISATION: `${COMMON_URL}information-sensibilisation/delete-is-isf`,
  GET_ISF_SENSIBILISATION: `${COMMON_URL}information-sensibilisation/information-sensibilisation`,
  UPLOAD_PDF_ISF_SENSIBILISATION: `${COMMON_URL}information-sensibilisation/upload-is-pdf`,

  POST_ISF_RECUEIL_DONNEES_PERSONNELLES: `${COMMON_URL}isf/recueil-donnee-personnel`,
  PUT_ISF_RECUEIL_DONNEES_PERSONNELLES: `${COMMON_URL}isf/recueil-donnee-personnel`,
  DELETE_ISF_RECUEIL_DONNEES_PERSONNELLES: `${COMMON_URL}isf/recueil-donnee-personnel`,
  GET_ISF_RECUEIL_DONNEES_PERSONNELLES: `${COMMON_URL}isf/recueil-donnee-personnel`,
  UPLOAD_PDF_ISF_RECUEIL_DONNEES_PERSONNELLES: `${COMMON_URL}isf/upload-recueil-donnee-personnel-pdf`,

  GET_ALL_PREFECTURE: `${COMMON_URL}codification/sous-prefecture`,
  POST_DTV_RAPPORT_ACTIVITES: `${COMMON_URL}dtv/rapport-activite`,
  PUT_DTV_RAPPORT_ACTIVITES: `${COMMON_URL}dtv/rapport-activite`,
  DELETE_DTV_RAPPORT_ACTIVITES: `${COMMON_URL}dtv/rapport-activite`,
  GET_DTV_RAPPORT_ACTIVITES: `${COMMON_URL}dtv/rapport-by-enquete`,
  GET_CALENDRIER_OUVERTURE_BY_CODE_SP: `${COMMON_URL}isf/calendrier-ouverture-by-sp`,
  GET_RECUEIL_DONNEES_PERSONNELLES_BY_CODE_SP: `${COMMON_URL}isf/recueil-donnee-personnel-by-sp`,
  GET_ISF_CEREMONIE_OUVERTURE_BY_CODE_SP: `${COMMON_URL}ceremonie-ouverture/ceremonie-ouverture-by-sp`,
  GET_ISF_DECLARATION_OUVERTURE_BY_CODE_SP: `${COMMON_URL}isf/declaration-ouverture-by-sp`,
  PUT_ISF_DECLARATION_OUVERTURE_SP: `${COMMON_URL}isf/update/declaration-ouverture-by-sp`,
  UPLOAD_PDF_DTV_RAPPORT_ACTIVITES: `${COMMON_URL}dtv/upload-rapport-activite-pdf`,

  GET_ISF_COURRIER_TRANSMISSION_BY_CODE_SP: `${COMMON_URL}elaboration-calendrier/courrier-trans-by-sp`,
  PUT_ISF_COURRIER_TRANSMISSION_BY_CODE_SP: `${COMMON_URL}elaboration-calendrier/update/courrier-trans-by-sp`,
  DELETE_ISF_COURRIER_TRANSMISSION_BY_CODE_SP: `${COMMON_URL}elaboration-calendrier/delete-courrier-trans`,

  DELETE_ISF_DECLARATION_OUVERTURE_BY_SP: `${COMMON_URL}isf/delete-declaration-ouverture-by-sp`,
  POST_ISF_DECLARATION_OUVERTURE_SP: `${COMMON_URL}isf/declaration-ouverture-by-sp`,
  GET_LIVRABLE_ISF_CVGFR_BY_CODE_SP: `${COMMON_URL}diagnostic/diagnostic-cvgfr-by-sp`,
  POST_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP: `${COMMON_URL}reunion-periodique/decision-designation-activite-by-sp`,
  PUT_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP: `${COMMON_URL}reunion-periodique/decision-designation-activite-by-sp`,
  GET_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP: `${COMMON_URL}reunion-periodique/decision-designation-activite-by-sp`,
  DELETE_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP: `${COMMON_URL}reunion-periodique/decision-designation-activite-by-sp`,
  UPLOAD_PDF_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP: `${COMMON_URL}reunion-periodique/upload-decision-pdf-sp`,

  GET_ISF_REUNION_PERIODIQUE_BY_CODE_SP: `${COMMON_URL}reunion-periodique/reunion-periodique-by-sp`,
  DELETE_ISF_REUNION_PERIODIQUE_BY_CODE_SP: `${COMMON_URL}reunion-periodique/delete-reunion-periodique-by-sp`,
  POST_ISF_REUNION_PERIODIQUE_SP: `${COMMON_URL}reunion-periodique/resume-resolution-sp`,
  UPDATE_ISF_REUNION_PERIODIQUE_SP: `${COMMON_URL}reunion-periodique/update-reunion-resolution-sp`,
  UPLOAD_PDF_REUNION_PERIODIQUE_SP: `${COMMON_URL}reunion-periodique/upload-resume-pdf-sp`,

  UPLOAD_PDF_ISF_DECLARATION_OUVERTURE_SP: `${COMMON_URL}isf/upload-declaration-ouverture-sp-pdf`,
  GET_ENQUETE_BY_CODE_SP: `${COMMON_URL}enquete/by-sp`,
  POST_PVCL_WITH_DCF: `${COMMON_URL}pvcl/new/with-dcf`,
  DELETE_DTV_ALL_RAPPORT_ACTIVITES: `${COMMON_URL}dtv/all-rapports-activites`,

  GET_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION: `${COMMON_URL}isf-complementaire/activite`,
  DELETE_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION: `${COMMON_URL}isf-complementaire/activite`,
  POST_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION: `${COMMON_URL}isf-complementaire/activite`,
  UPDATE_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION: `${COMMON_URL}isf-complementaire/activite`,
  UPLOAD_PDF_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION: `${COMMON_URL}isf-complementaire/upload-activite-pdf`,

  GET_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT:  `${COMMON_URL}isf-complementaire/formation-encadrement`,
  DELETE_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT:  `${COMMON_URL}isf-complementaire/formation-encadrement`,
    POST_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT:  `${COMMON_URL}isf-complementaire/formation-encadrement`,
  UPDATE_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT:  `${COMMON_URL}isf-complementaire/formation-encadrement`,
  UPLOAD_PDF_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT: `${COMMON_URL}isf-complementaire/upload-formation-encadrement-pdf`,

  

  GET_ISF_COMPLEMENTAIRE_FACILITATION: `${COMMON_URL}isf-complementaire/facilitation`,
  DELETE_ISF_COMPLEMENTAIRE_FACILITATION: `${COMMON_URL}isf-complementaire/facilitation`,
  POST_ISF_COMPLEMENTAIRE_FACILITATION: `${COMMON_URL}isf-complementaire/facilitation`,
  UPDATE_ISF_COMPLEMENTAIRE_FACILITATION: `${COMMON_URL}isf-complementaire/facilitation`,
  UPLOAD_PDF_ISF_COMPLEMENTAIRE_FACILITATION: `${COMMON_URL}isf-complementaire/upload-facilitation-pdf`,

  GET_DTV_SCAN_DOCUMENT: `${COMMON_URL}dtv/scan-document`,
  DELETE_DTV_SCAN_DOCUMENT: `${COMMON_URL}dtv/delete-scan-document`,
  DELETE_DTV_ALL_SCAN_DOCUMENT: `${COMMON_URL}dtv/delete-all-documents`,
  POST_DTV_SCAN_DOCUMENT: `${COMMON_URL}dtv/upload-dtv-scan-fichiers`,
  UPDATE_DTV_SCAN_DOCUMENT: `${COMMON_URL}dtv/update-dtv-scan-fichiers`,
};


export const contactApi = (payload) => {
  return apis.post(API_URLS.SEND_MESSAGE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putDesignationGestionnaireCFC = (codepvrdc, payload) => {
  return apis.put(`${API_URLS.PUT_DESIGNATION_GESTIONNAIRECFC}/${codepvrdc}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateDO = (payload) => {
  return apis.post(API_URLS.UPDATE_DECLARATION_OUVERTURE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const findTransmissionByCodeCla = (code_cla, payload) => {
  const apiUrl = `${API_URLS.GET_TL}/${code_cla}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateTL = (payload) => {
  return apis.post(API_URLS.UPDATE_TRANSMISSION_LETTRE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteDO = (code_cla, payload) => {
  const apiUrl = `${API_URLS.DELETE_DO}/${code_cla}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteTL = (code_cla, payload) => {
  const apiUrl = `${API_URLS.DELETE_TL}/${code_cla}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const createAnpPdf = (payload) => {
  return apis.post(API_URLS.PDF_DEMANDES_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDeclarationOuverture = (payload) => {
  return apis.post(API_URLS.POST_DECLARATION_OUVERTURE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postTransmissionLettre = (payload) => {
  return apis.post(API_URLS.POST_TRANSMISSION_LETTRE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const get_list_pub_unique = (codepub, payload) => {
  const apiUrl = `${API_URLS.LIST_PUB_UNIQUE}/${codepub}`;

  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const get_list_pub = (code, payload) => {
  const apiUrl = `${API_URLS.LIST_PUB}/${code}`;

  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateAnnoncePub = (payload) => {
  return apis.post(API_URLS.UPDATE_ANNONCE_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const generateContrat = (payload) => {
  return apis.post(API_URLS.GENERATE_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addServitude = (payload) => {
  return apis.post(API_URLS.ADD_SERVITUDE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addDateServitude = (payload) => {
  return apis.post(`${COMMON_URL}pvrdc/add-servitude`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateServitude = (code_pvrdc, payload) => {
  return apis.put(`${COMMON_URL}pvrdc/update-servitude/${code_pvrdc}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addEtatDeDroit = (payload) => {
  return apis.post(API_URLS.ADD_ETAT_DE_DROIT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateEtatDeDroitCF = (code, payload) => {
  const apiUrl = `${API_URLS.UPDATE_ETAT_DE_DROIT}/${code}`;

  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteVALID = (codevalid, payload) => {
  const apiUrl = `${API_URLS.DELETE_VALID}/${codevalid}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteCECPDC = (codececpdc, payload) => {
  const apiUrl = `${API_URLS.DELETE_CECPDC}/${codececpdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteANP = (code_annonce_pub, payload) => {
  const apiUrl = `${API_URLS.DELETE_ANP}/${code_annonce_pub}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteANPC = (code_annonce_pub, payload) => {
  const apiUrl = `${API_URLS.DELETE_ANPC}/${code_annonce_pub}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteANPO = (code_annonce_pub, payload) => {
  const apiUrl = `${API_URLS.DELETE_ANPO}/${code_annonce_pub}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteCLP = (codeclp, payload) => {
  const apiUrl = `${API_URLS.DELETE_CLP}/${codeclp}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePVCL = (codepvcl, payload) => {
  const apiUrl = `${API_URLS.DELETE_PVCL}/${codepvcl}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeFicheDemographique = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS.DELETE_PVRDC_FICHE_DEMOGRAPHIQUE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeEquipeEnquete = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS.DELETE_PVRDC_ANNEXE_EQUIPE_ENQUETE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeDeclarationOccupant = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS.DELETE_PVRDC_ANNEXE_DECLARATION_OCCUPANT}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeOccupantParcelle = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS.DELETE_PVRDC_ANNEXE_OCCUPANT_PARCELLE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeFicheLitige = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS.DELETE_PVRDC_ANNEXE_FICHE_LITIGE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeDetenteurDroit = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS.DELETE_PVRDC_ANNEXE_DETENTEUR_DROIT}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeEtatDroit = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS.DELETE_PVRDC_ANNEXE_ETAT_DROIT}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePVRDC = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS.DELETE_PVRDC}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeDesignationGestionnaire = (
  codepvrdc,
  payload
) => {
  const apiUrl = `${API_URLS.DELETE_PVRDC_ANNEXE_DESIGNATION_GESTIONNAIRE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeServitude = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS.DELETE_PVRDC_ANNEXE_SERVITUDE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeSignatureDesignationGestionnaire = (
  codepvrdc,
  payload
) => {
  const apiUrl = `${API_URLS.DELETE_PVRDC_ANNEXE_SIGNATURE_DESIGNATION_GESTIONNAIRE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteDCF = (codedcf, payload) => {
  const apiUrl = `${API_URLS.DELETE_DCF}/${codedcf}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const TransmissionDCF = (NNNNN, payload) => {
  const apiUrl = `${API_URLS.TRANSMISSION_DCF}/${NNNNN}`;

  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const TransmissionDCFbyenquete = (numero_enquete, payload) => {
  const apiUrl = `${API_URLS.TRANSMISSION_DCF_ENQUETE}/${numero_enquete}`;

  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteCF = (codedcf, payload) => {
  const apiUrl = `${API_URLS.DELETE_CF}/${codedcf}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getNumContratByEnquete = (ide, payload) => {
  const apiUrl = `${API_URLS.GET_NUM_CONTRAT_ENQUETE}/${ide}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updatePVCL = (payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.UPDATE_PVCL}`;
  // Make the GET request with the constructed URL
  return apis.post(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteAnnexesPVCL = (ida, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.DELETE_ANNEXES_PVCL}/${ida}`;
  // Make the GET request with the constructed URL
  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateAnnexesPVCL = (ida, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.UPDATE_ANNEXES_PVCL}/${ida}`;
  // Make the GET request with the constructed URL
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getParcelleGeomatic = async (num_dcf) => {
  const response = await axios.get(
    `${API_URLS.GET_PARCELLE_GEOMATIC}/${num_dcf}`,
    {
      headers: {
        Authorization: `Bearer ${GEOMATIC_TOKEN}`,
      },
    }
  );
  return response;
};

export const updateDemandeCF = (codedcf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.UPDATE_DEMANDE_CF}/${codedcf}`;
  // Make the GET request with the constructed URL
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getAllNumDCF = (payload) => {
  return apis.get(API_URLS.GET_ALL_NUM_DCF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const refreshToken = (idu, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.REFRESH_TOKEN_USER}/${idu}`;
  // Make the GET request with the constructed URL
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const changePSWD = (idu, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.CHANGE_PSWD_USER}/${idu}`;
  // Make the GET request with the constructed URL
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const forgotPSWD = (payload) => {
  return apis.post(API_URLS.FORGOT_PSWD_USER, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPDFCLP = (payload) => {
  return apis.post(API_URLS.POST_PDF_CLP, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getCLP = (codeCLP, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_CLP}/${codeCLP}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const downloadApp = async (payload) => {
  try {
    const apiUrl = `${API_URLS.DOWNLOAD_MOBILE_APP}/${payload.ENV}/${payload.os}`;
    const response = await axios.get(apiUrl, {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    const app_name = `CGEDS_${payload.ENV}_${payload.os}.apk`;
    link.setAttribute('download', app_name); // Nom du fichier à télécharger
    document.body.appendChild(link);
    link.click();

    // Optionnel : Nettoyer après téléchargement
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading the APK:', error);
  }
};

export const getEnqueteByCode = (code_enquete, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_ENQUETE_BY_CODE}/${code_enquete}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postAnnexesCLP = (payload) => {
  return apis.post(API_URLS.POST_ANNEXES_CLP, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postCLP = (payload) => {
  return apis.post(API_URLS.POST_CLP, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const downloadPPDSHP = (nnnnn, payload) => {
  // Construct the URL for fetching the zip file by name
  let apiUrl = `${API_URLS.GET_PPD_SHP}/${nnnnn}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: {
      'Content-Type': 'application/json',
      ...payload?.headers,
    },
    responseType: 'arraybuffer',
  });
};

export const downloadPPPSHP = (nnnnn, payload) => {
  // Construct the URL for fetching the zip file by name
  let apiUrl = `${API_URLS.GET_PPP_SHP}/${nnnnn}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: {
      'Content-Type': 'application/json',
      ...payload?.headers,
    },
    responseType: 'arraybuffer',
  });
};

export const readPPDPDF = (nnnnn, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  let apiUrl = `${API_URLS.GET_PPD_PDF}/${nnnnn}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: {
      'Content-Type': 'application/json',
      ...payload?.headers,
    },
    responseType: 'arraybuffer',
  });
};

export const readPPPPDF = (nnnnn, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  let apiUrl = `${API_URLS.GET_PPP_PDF}/${nnnnn}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: {
      'Content-Type': 'application/json',
      ...payload?.headers,
    },
    responseType: 'arraybuffer',
  });
};

export const patchInfoCF = (payload) => {
  const apiUrl = `${API_URLS.UPDATE_INFO_CF}`;
  // Make the GET request with the constructed URL
  return apis.patch(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const patchStatusDemande = (payload) => {
  const apiUrl = `${API_URLS.UPDATE_STATUS_DEMANDE}`;
  // Make the GET request with the constructed URL
  return apis.patch(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const findUser = (code, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.UPDATE_USER}/${code}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// export const deleteUser = (payload) =>
//   apis.delete(API_URLS.UPDATE_USER, {
//     ...payload?.data,
//     headers: { "Content-Type": "application/json", ...payload?.headers },
//   });

export const postPDFPVO = (payload) => {
  return apis.post(API_URLS.POST_PDF_PVO, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const patchEtatDemande = (payload) => {
  return apis.patch(API_URLS.UPDATE_ETAT_DEMANDE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPVO = (payload) => {
  return apis.post(API_URLS.POST_PVO, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postANPO = (payload) => {
  return apis.post(API_URLS.POST_ANPO, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateANPO = (payload) => {
  return apis.post(API_URLS.UPDATE_ANPO, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updatepvo = (code_dcfpvo, payload) => {
  return apis.put(
    `${COMMON_URL}certificat-foncier/update-dcf-pvo/${code_dcfpvo}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const postPVOPresence = (payload) => {
  return apis.post(API_URLS.POST_PVO_PRESENCE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const readPDF = (payload) => {
  // Construct the URL by appending the contract ID to the base URL
  let apiUrl = `${API_URLS.READ_PDF_CF}`;

  // Make the GET request with the constructed URL
  return apis.post(apiUrl, {
    ...payload,
    headers: {
      'Content-Type': 'application/json',
      ...payload?.headers,
    },
    responseType: 'arraybuffer',
  });
};

export const postPDFCF = (payload) => {
  return apis.post(API_URLS.POST_PDF_CF, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postPDFDCF = (payload) => {
  return apis.post(API_URLS.POST_PDF_DCF, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const post_PDF_PVRDC = (payload) => {
  return apis.post(API_URLS.POST_PDF_PVRDC, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postPDFCFPiece = (payload) => {
  return apis.post(API_URLS.POST_PDF_CFPIECE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postPDFCFPieceClient = (payload) => {
  return apis.post(API_URLS.POST_PDF_CFPIECE_CLIENT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updatePDFCFPiece = (payload) => {
  return apis.put(API_URLS.UPDATE_PDF_CFPIECE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postPDFConstat = (payload) => {
  return apis.post(API_URLS.POST_PDF_CONSTAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getConstat = (codeconstat, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_CONSTAT}/${codeconstat}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postAnnexesConstat = (payload) => {
  return apis.post(API_URLS.POST_ANNEXES_CONSTAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postConstat = (payload) => {
  return apis.post(API_URLS.POST_CONSTAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateconstat = (code_constat, payload) => {
  return apis.put(`${COMMON_URL}constat/update-constat/${code_constat}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

/* export const updateconstat = (code_constat, payload) =>
  apis.put(`${COMMON_URL}constat/update-constat/${code_constat}`, {
    ...payload,
    headers: { "Content-Type": "application/json", ...payload?.headers },
  });
 */

export const postPDFCloturePub = (payload) => {
  return apis.post(API_URLS.POST_PDF_CLOTUREPUB, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postPDFOuverturePub = (payload) => {
  return apis.post(API_URLS.POST_PDF_OUVERTUREPUB, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const createCloturePubPDF = (payload) => {
  return apis.post(API_URLS.CREATE_CLOTUREPUB_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPDFPub = (payload) => {
  return apis.post(API_URLS.POST_PDF_PUB, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getAnnoncePub = (codepub, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.ANNONCE_PUB}/${codepub}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPDFPVCL = (payload) => {
  return apis.post(API_URLS.POST_PDF_PVCL, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getPVCL = (codepvcl, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_PVCL}/${codepvcl}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getLogActivity = (codeId, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.LOG_ACTIVITY}/${codeId}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDemandesPub = (payload) => {
  return apis.post(API_URLS.POST_DEMANDES_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// export const updateCloturePub = (payload) => {
//   console.log("payload depuis service api ", payload)
//   apis.post(API_URLS.UPDATE_PV_CLOTURE_PUB, {
//     ...payload,
//     headers: { "Content-Type": "application/json", ...payload?.headers },
//   });
// }

export const updateCloturePub = (payload) => {
  return apis.post(API_URLS.UPDATE_PV_CLOTURE_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postCloturePub = (payload) => {
  return apis.post(API_URLS.POST_CLOTURE_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postAnnoncePub = (payload) => {
  return apis.post(API_URLS.ANNONCE_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postAnnexesPVCL = (payload) => {
  return apis.post(API_URLS.POST_ANNEXES_PVCL, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPVCL = (payload) => {
  return apis.post(API_URLS.POST_PVCL, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getCF = (codecf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_CF}/${codecf}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getPVRDC = async (codecf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_PVRDC}/${codecf}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getDcfConstats = async (codecf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_DCF_CONSTATS}/${codecf}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getAnnoncePublicite = async (code_certif, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_DCF_ANNONCE_PUBLICITE}/${code_certif}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDemandeCF = (payload) => {
  return apis.post(API_URLS.POST_DEMANDE_CF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDesignationGestionnaireCFC = (payload) => {
  return apis.post(API_URLS.POST_DESIGNATION_GESTIONNAIRECFC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postAEFC = (payload) => {
  return apis.post(API_URLS.POST_AEFC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postAEFJ = (payload) => {
  return apis.post(API_URLS.POST_AEFJ, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addSignataireDesignationGestionnaireCFC = (payload) => {
  return apis.post(API_URLS.ADD_SIGNATAIRE_BIEN_FONCIER, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateSignataireDesignationGestionnaireCFC = (
  code_pvrdc,
  payload
) => {
  return apis.put(`${COMMON_URL}pvrdc/update-design-gestion/${code_pvrdc}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPVRDC = (payload) => {
  return apis.post(API_URLS.POST_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updatePVRDC = (payload) => {
  return apis.post(API_URLS.UPDATE_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addMembreEquipEnqPVRDC = (payload) => {
  return apis.post(API_URLS.ADD_MEMBRE_EQUIPE_ENQ_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateMembreEquipEnqPVRDC = (payload) => {
  return apis.put(API_URLS.UPDATE_MEMBRE_EQUIPE_ENQ_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteMembreEquipEnqPVRDC = (payload) => {
  return apis.delete(API_URLS.DELETE_MEMBRE_EQUIPE_ENQ_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addmembreFicheDemo = (payload) => {
  return apis.post(API_URLS.POST_FICHE_DEMO_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addDeclarationPVRDC = (payload) => {
  return apis.post(API_URLS.ADD_DECLARATION_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateDeclarationPVRDC = (payload) => {
  return apis.put(`${API_URLS.UPDATE_DECLARATION_PVRDC}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteDeclarationPVRDC = (id) => {
  return apis.delete(`${API_URLS.DELETE_DECLARATION_PVRDC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addLitigePVRDC = (payload) => {
  return apis.post(API_URLS.ADD_LITIGE_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addFicheLitigePVRDC = (payload) => {
  return apis.post(API_URLS.ADD_FICHE_LITIGE_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};
export const updateFicheLitigePVRDC = async (code_pvrdc, payload) => {
  const apiUrl = `${API_URLS.UPDATE_FICHE_LITIGE_PVRDC}/${code_pvrdc}`;
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addOccupantParcelle = (payload) =>
  apis.post(API_URLS.ADD_OCCUPANT_PARCELLE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const deleteOccupantParcelle = async (
  code_occ_parcelle,
  payload = {}
) => {
  const lastUrl = `${API_URLS.DELETE_OCCUPANT_PARCELLE}/${code_occ_parcelle}`;
  return apis.delete(lastUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateOccupantParcelle = async (code_occ_parcelle, payload) => {
  const apiUrl = `${API_URLS.UPDATE_OCCUPANT_PARCELLE}/${code_occ_parcelle}`;
  apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addOccupantParcelleDate = (payload) =>
  apis.post(API_URLS.ADD_OCCUP_PARCELLE_DATE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
//updte
export const updateOccupantParcelleDate = async (code_occ_date, payload) => {
  const apiUrl = `${API_URLS.UPDATE_OCCUP_PARCELLE_DATE}/${code_occ_date}`;
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addListeServitude = (payload) =>
  apis.post(API_URLS.ADD_LISTE_SERVITUDE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const addDetenteursDeDroitsCF = (payload) => {
  return apis.post(API_URLS.ADD_DETENTEURS_DE_DROITS_CF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addDateDetenteursDeDroitsCF = (payload) => {
  return apis.post(`${COMMON_URL}pvrdc/add-listeddcc`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateDetenteursDeDroitsCF = async (code_pvrdc, payload) => {
  return apis.put(`${COMMON_URL}pvrdc/update-listeddcc/${code_pvrdc}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updatePvPublicite = (payload) => {
  const apiUrl = `${COMMON_URL}/certificat-foncier/update-anp`;
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addEtatDeDroitCF = (payload) =>
  apis.post(API_URLS.ADD_ETAT_DE_DROIT_PROP, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const addAyantDroit = (payload) =>
  apis.post(API_URLS.ADD_AYANT_DROIT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const postTemoinContrat = (payload) =>
  apis.post(API_URLS.POST_TEMOIN_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const updateTemoinContrat = (payload) =>
  apis.post(API_URLS.UPDATE_TEMOIN_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const postCecpdcPdf = (payload) =>
  apis.post(API_URLS.POST_CECPDC_PDF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const postValidPdf = (payload) =>
  apis.post(API_URLS.POST_VALID_PDF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const postPDFContrat = (payload) =>
  apis.post(API_URLS.POST_PDF_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const updateProcurationContrat = (payload) =>
  apis.post(API_URLS.UPDATE_PROCURATION_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const postPDFCNI = (payload) => {
  return apis.post(API_URLS.POST_PDF_CNI_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postFicheIdentification = (payload) => {
  return apis.post(API_URLS.POST_FICHE_IDENTIFICATION, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updateFicheIdentification = (id, payload) => {
  return apis.put(`${API_URLS.UPDATE_FICHE_IDENTIFICATION}/${id}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updatePDFCNI = (payload) =>
  apis.post(API_URLS.POST_PDF_CNI_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const postPDFCroquis = (payload) =>
  apis.post(API_URLS.POST_PDF_CROQUIS_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const postPDFProcuration = (payload) => {
  return apis.post(API_URLS.POST_PDF_PROCURATION_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updatePDFProcuration = (payload) =>
  apis.post(API_URLS.UPDATE_PDF_PROCURATION_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const postAnnexesContrat = (payload) => {
  return apis.post(API_URLS.POST_ANNEXES_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updateAnnexesContrat = (payload) =>
  apis.post(API_URLS.UPDATE_ANNEXES_CONTRAT, {
    ...payload?.data.getAll(),
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const updatePDFCroquis = (payload) =>
  apis.post(API_URLS.UPDATE_ANNEXES_CROQUIS, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const readContractFiles = (payload) => {
  return apis.post(API_URLS.READ_PDF_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
    responseType: 'arraybuffer',
  });
};

export const getContratByEnquete = (codeenquete, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_CONTRAT_ENQ}/${codeenquete}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const readpdfprocuration = (idproducration, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.READ_PDF_PROCURATION}/${idproducration}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const readpdfcroquis = (idcroquis, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.READ_PDF_CROQUIS}/${idcroquis}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const readpdfpiece = (idpiece, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.READ_PDF_PIECESID}/${idpiece}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const readPDFAnnexesContrat = (idAnnexe, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.READ_PDF_ANNEXES}/${idAnnexe}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getCertificatByEnquete = (codeEnquete, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_CF_BY_ENQ}/${codeEnquete}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getContrat = (codecontrat, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_CONTRAT}/${codecontrat}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postSoussigneContrat = (payload) =>
  apis.post(API_URLS.POST_SOUSSIGNE_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const updateSoussigneContrat = (person_id, payload) => {
  const apiUrl = `${API_URLS.PUT_SOUSSIGNE_CONTRAT}/${person_id}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postContrat = (payload) =>
  apis.post(API_URLS.POST_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const updateContrat = (code_contrat, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.UPDATE_CONTRAT}/${code_contrat}`;
  // Make the GET request with the constructed URL
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteContrat = (codecontrat, payload) => {
  const apiUrl = `${API_URLS.GET_DELETE_CONTRAT}/${codecontrat}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getEnqueteByUser = (payload) =>
  apis.get(API_URLS.GET_ENQUETE_USER, payload);

export const getEnqueteAll = (payload) =>
  apis.get(API_URLS.GET_ENQUETE_ALL, payload);

export const getOnlyEnqueteAll = (payload) =>
  apis.get(API_URLS.GET_ONLY_ENQUETE_ALL, payload);

export const checkEnqueteNumero = (payload) =>
  apis.post(API_URLS.GET_ONLY_ENQUETE_ALL_CLIENT, {
    ...payload,
    headers: { ...payload?.headers },
  });

export const postDemandeClient = (payload) =>
  apis.post(API_URLS.POST_DCF_DEMANDE_CLIENT, {
    ...payload,
    headers: { ...payload?.headers },
  });

export const createClientEnquete = (payload) =>
  apis.post(API_URLS.POST_ENQUETE_CLIENT, {
    ...payload,
    headers: { ...payload?.headers },
  });

// export const createClientEnquete = async (payload) => {
//   return apis.post(API_URLS.POST_ENQUETE_CLIENT, payload)
//     .then(response => {
//       return response.data;
//     })
//     .catch(error => {
//       console.error("Erreur lors de l'envoi de l'enquête :", error);
//       throw error;
//     });
// }

export const getContratAll = (payload) =>
  apis.get(API_URLS.GET_CONTRAT_ALL, payload);

export const getCommuneVil = (codecommune, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_COMMUNE_VIL}/${codecommune}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getSpCommune = (codesp, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_SP_COMMUNE}/${codesp}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getDepSp = (codedep, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_DEP_SP}/${codedep}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const regionDep = (coderegion, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_REGION_DEP}/${coderegion}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getRegions = (payload) => apis.get(API_URLS.GET_REGIONS, payload);

export const postUserResendEmail = (payload) =>
  apis.post(API_URLS.POST_USER_RESEND_EMAIL, payload);

export const postUserConfirmEmail = (payload) => {
  return apis.post(API_URLS.POST_USER_CONFIRM_EMAIL, payload);
};

export const postEnquete = (payload) => {
  return apis.post(API_URLS.POST_ENQUETE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const signinUser = (payload) => apis.post(API_URLS.SIGNIN_USER, payload);

export const signupUser = (payload) => apis.post(API_URLS.SIGNUP_USER, payload);

export const listUser = (payload) =>
  apis.post(API_URLS.LIST_USER, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

// api for Contrat and User Management
const createHeaders = (accessToken) => ({
  Authorization: `Bearer ${accessToken}`,
  'Content-Type': 'application/json',
});

export const listUsersApi = (accessToken) => {
  return apis.get(`${COMMON_URL}user/all`, {
    headers: createHeaders(accessToken),
  });
};

export const listDeteledUsersApi = (accessToken) => {
  return apis.get(`${COMMON_URL}user/all-user-trashed`, {
    headers: createHeaders(accessToken),
  });
};

export const getUserApi = (accessToken, userId) => {
  return apis.get(`${COMMON_URL}user/${userId}`, {
    headers: createHeaders(accessToken),
  });
};

export const checkAdmin = () => {
  return apis.get(`${COMMON_URL}user/check-admin`, {});
};

export const changePassword = async (accessToken, userId, data) => {
  try {
    const response = await axios.put(
      `${COMMON_URL}user/change-password/${userId}`,
      data,
      {
        headers: createHeaders(accessToken),
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const deleteUserApi = (accessToken, userId) => {
  return apis.delete(`${COMMON_URL}user/${userId}`, {
    headers: createHeaders(accessToken),
  });
};

export const recoveryUserApi = (accessToken, userId) => {
  return apis.put(`${COMMON_URL}user/recover/${userId}`, {
    headers: createHeaders(accessToken),
  });
};

export const getallCf = (payload) =>
  apis.get(`${COMMON_URL}certificat-foncier/cf/all`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

// export const getAllDcfClient = () =>{
//   apis.get(API_URLS.GET_ALL_DCF_CLIENT);
//   };

export const getAllDcfClient = (payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_ALL_DCF_CLIENT}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getallDcf = (payload, numero_enquete = null) =>
  apis.get(
    `${COMMON_URL}${
      numero_enquete
        ? 'certificat-foncier/by-enquete/' + numero_enquete
        : 'certificat-foncier/list-dcf'
    }`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );

export const updateUser = async (accessToken, userId, userData) => {
  try {
    const response = await axios.put(`${COMMON_URL}user/${userId}`, userData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};
export const updateFicheDemo = (code_pvrdc, payload) => {
  return apis.put(`${COMMON_URL}pvrdc/update-fiche-demo/${code_pvrdc}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addFicheDemoDate = (payload) =>
  apis.post(`${COMMON_URL}pvrdc/add-fiche-demo`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const addSignatairesDesignGestDate = (payload) => {
  return apis.post(`${COMMON_URL}pvrdc/add-design-gestion`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateclp = (code_clp, payload) =>
  apis.put(`${COMMON_URL}clp/update-clp/${code_clp}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const updatelppcl = (lppclId, payload) => {
  const apiUrl = `${COMMON_URL}clp/update-clp-lppc/${lppclId}`;
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateUserStatus = async (accessToken, userId, isActive) => {
  try {
    const response = await axios.put(
      `${COMMON_URL}user/active/${userId}`,
      { isActive },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user status:', error);
    throw error;
  }
};

export const updateUserRole = async (accessToken, userId, role) => {
  try {
    const response = await axios.put(
      `${COMMON_URL}user/add-role/${userId}`,
      { role: role },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user role:', error);
    throw error;
  }
};

// statisticsApi.js

export const fetchUserData = async (accessToken) => {
  try {
    const response = await axios.get(`${COMMON_URL}user/all`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response?.data?.data || [];
  } catch (error) {
    console.error('Error fetching contract data:', error);
    throw error;
  }
};

export const fetchContractData = async (accessToken, numero_enquete = null) => {
  try {
    const response = await axios.get(
      `${COMMON_URL}${
        numero_enquete ? 'contrat/by-enquete/' + numero_enquete : 'contrat/all'
      }`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return numero_enquete ? response.data || [] : response?.data?.data || [];
  } catch (error) {
    console.error('Error fetching contract data:', error);
    throw error;
  }
};

export const fetchAllVillages = async (accessToken) => {
  try {
    const response = await axios.get(`${COMMON_URL}enquete/all`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response?.data?.data || [];
  } catch (error) {
    console.error('Error fetching all villages:', error);
    throw error;
  }
};

export const findNumeroEnqueteForRegion = async (accessToken, region) => {
  try {
    // Fetch data to get numero_enquete for the selected region
    const response = await axios.get(
      `${COMMON_URL}enquete/by-region/${region}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    // Assuming the response is an array
    const data = response?.data?.data || [];
    return data;
  } catch (error) {
    console.error(`Error fetching numero_enquete for region ${region}:`, error);
    throw error; // Propagate the error for the caller to handle
  }
};

export const fetchCertificateData = async (
  accessToken,
  numero_enquete = null
) => {
  try {
    const response = await axios.get(
      `${COMMON_URL}${
        numero_enquete
          ? 'certificat-foncier/by-enquete/' + numero_enquete
          : 'certificat-foncier/cf/all'
      }`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return numero_enquete ? response.data || [] : response?.data?.data || [];
  } catch (error) {
    console.error('Error fetching contract data:', error);
    throw error;
  }
};

export const fetchCertificateDataByEnquete = async (accessToken) => {
  try {
    const response = await axios.get(
      `${COMMON_URL}certificat-foncier/list-dcf`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // console.log(response);
    return response.data || [];
  } catch (error) {
    console.error('Error fetching certificate data:', error);
    throw error;
  }
};

export const fetchDcfData = async (accessToken, numero_enquete = null) => {
  try {
    const response = await axios.get(
      `${COMMON_URL}${
        numero_enquete
          ? 'certificat-foncier/by-enquete/' + numero_enquete
          : 'certificat-foncier/list-dcf'
      }`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // console.log(response);
    return numero_enquete ? response.data || [] : response?.data?.data || [];
  } catch (error) {
    console.error('Error fetching contract data:', error);
    throw error;
  }
};

export const getOneOta = (id, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS.GET_ONE_OTA}/${id}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const listAllOtaApi = (payload) => {
  const apiUrl = `${COMMON_URL}ota/all`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addOtaApi = (payload) =>
  apis.post(API_URLS.ADD_OTA, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const deleteOtaApi = (accessToken, otaId) => {
  return apis.delete(`${COMMON_URL}ota/${otaId}`, {
    headers: createHeaders(accessToken),
  });
};

export const updateOtaApi = async (accessToken, otaId, otaData) => {
  try {
    const response = await axios.put(`${COMMON_URL}ota/${otaId}`, otaData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const recoveryOtaApi = (accessToken, otaId) => {
  return apis.put(`${COMMON_URL}ota/recover/${otaId}`, {
    headers: createHeaders(accessToken),
  });
};

export const listDeteledOtasApi = (accessToken) => {
  return apis.get(`${COMMON_URL}ota/all-ota-trashed`, {
    headers: createHeaders(accessToken),
  });
};

export const getVillagesByCodeSpVil = (code_enquete) => {
  return apis.get(`${API_URLS.GET_VILLAGES_BY_CODE_ENQUETE}/${code_enquete}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// export const createDcfAnpPdfs = (payload) => {
//   return apis.post(API_URLS.CREATE_DCF_ANP_PDFS, {
//     ...payload,
//     headers: { 'Content-Type': 'application/json', ...payload?.headers },
//   });
// }

export const post_tv_Histo = (payload) => {
  return apis.post(API_URLS.POST_DTV_HISTO, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDtvAttestationApprobationEnquete = (payload) => {
  console.log(payload);
  return apis.post(API_URLS.POST_ATTESTATION_APPROBATION_ENQUETE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDtvAttestationValidationEnquete = (payload) => {
  return apis.post(API_URLS.POST_ATTESTATION_VALIDATION_ENQUETE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getParticipantsAttestationValidationEnqueteFonciereRurale = (
  code_enquete
) => {
  return apis.get(
    `${API_URLS.GET_PARTICIPANTS_ATTESTATION_VALIDATION_ENQUETE_RURAL}/${code_enquete}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getEnqueteDtv = (numero_enquete) => {
  return apis.get(`${API_URLS.GET_DTV_BY_ENQUETE}/${numero_enquete}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const putDtvAttestationApprobationEnquete = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ATTESTATION_APPROBATION_ENQUETE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putDtvAttestationValidationEnquete = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ATTESTATION_VALIDATION_ENQUETE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const put_tv_Histo = (id, payload) => {
  return apis.put(`${API_URLS.POST_DTV_HISTO}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getTroncons = (payload) => {
  return apis.get(`${API_URLS.GET_TRONCONS}/${payload}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const createTroncon = (payload) => {
  return apis.post(`${API_URLS.POST_TRONCON}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateTroncon = (id, payload) => {
  return apis.put(`${API_URLS.PUT_TRONCON}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteTroncon = (payload) => {
  return apis.delete(`${API_URLS.DELETE_TRONCON}/${payload}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteTronconByEnquete = (payload) => {
  return apis.delete(`${API_URLS.DELETE_TRONCON_ALL}/${payload}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDTVANP = (payload) => {
  return apis.post(API_URLS.POST_DTV_ANP, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putDTVANP = (id, payload) => {
  return apis.put(`${API_URLS.PUT_DTV_ANP}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDTVANPO = (payload) => {
  return apis.post(API_URLS.POST_DTV_ANPO, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};
export const putDTVANPO = (id, payload) => {
  return apis.put(`${API_URLS.PUT_DTV_ANPO}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const createAnpc = (payload) => {
  return apis.post(`${API_URLS.POST_ANPC}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvHisto = (id) => {
  return apis.delete(`${API_URLS.DELETE_PV_HISTO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postHistoPdf = (payload) => {
  return apis.post(API_URLS.POST_HISTO_PIECE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const deleteDTVANP = (id) => {
  return apis.delete(`${API_URLS.DELETE_DTV_ANP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteDTVANPO = (id) => {
  return apis.delete(`${API_URLS.DELETE_DTV_ANPO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postANPPdf = (payload) => {
  return apis.post(API_URLS.POST_ANP_PIECE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postANPOPdf = (payload) => {
  return apis.post(API_URLS.POST_ANPO_PIECE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};
export const getAnpByEnquete = (id) => {
  return apis.get(`${API_URLS.GET_ANP_BY_ENQUETE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const putAnpc = (id, payload) => {
  return apis.put(`${API_URLS.UPDATE_DTV_ANPC}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteAnpc = (id) => {
  return apis.delete(`${API_URLS.DELETE_DTV_ANPC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteDtvAttestationApprobationEnquete = (id) => {
  return apis.delete(
    `${API_URLS.DELETE_ATTESTATION_APPROBATION_ENQUETE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const deleteDtvAttestationValidationEnquete = (id) => {
  return apis.delete(
    `${API_URLS.DELETE_ATTESTATION_VALIDATION_ENQUETE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadAnpcPdf = (payload) => {
  return apis.post(API_URLS.UPLOAD_DTV_ANPC, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadApprobPdf = (payload) => {
  return apis.post(API_URLS.UPLOAD_ATTESTATION_APPROBATION_ENQUETE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadValidationPdf = (payload) => {
  return apis.post(API_URLS.UPLOAD_ATTESTATION_VALIDATION_ENQUETE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updloadPVLIM = (payload) => {
  return apis.post(API_URLS.UPLOAD_PVLIM, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const genererPdfConstatLimiteTroncon = async (payload) => {
  return await apis.post(API_URLS.GENERER_PDF_CONSTAT_LIMITE_TRONCON, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addIsfCalendrierOuverture = (payload) => {
  // console.log(payload);
  return apis.post(API_URLS.POST_CALENDRIER_OUVERTURE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};
export const getIsfCalendrierOuverture = (id) => {
  return apis.get(`${API_URLS.GET_CALENDRIER_OUVERTURE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfCalendrierOuverture = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_CALENDRIER_OUVERTURE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const genererPdfIsfCalendrierOuverture = (id) => {
  return apis.get(`${API_URLS.GENERER_PDF_CALENDRIER_OUVERTURE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateIsfCalendrierOuverture = (id, payload) => {
  return apis.put(`${API_URLS.PUT_CALENDRIER_OUVERTURE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCalendrierOuverture = (id) => {
  return apis.delete(`${API_URLS.DELETE_CALENDRIER_OUVERTURE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addIsfListePresenceContact = (payload) => {
  // console.log(payload);
  return apis.post(API_URLS.POST_LISTE_PRESENCE_CONTACT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};
export const getIsfListePresenceContact = (id) => {
  return apis.get(`${API_URLS.GET_LISTE_PRESENCE_CONTACT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfListePresenceContact = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_LISTE_PRESENCE_CONTACT}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const genererPdfIsfListePresenceContact = (id) => {
  return apis.get(`${API_URLS.GENERER_PDF_LISTE_PRESENCE_CONTACT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateIsfListePresenceContact = (id, payload) => {
  return apis.put(`${API_URLS.PUT_LISTE_PRESENCE_CONTACT}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfListePresenceContact = (id) => {
  return apis.delete(`${API_URLS.DELETE_LISTE_PRESENCE_CONTACT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addIsfCompteRenduContact = (payload) => {
  // console.log(payload);
  return apis.post(API_URLS.POST_COMPTE_RENDU_CONTACT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};
export const getIsfCompteRenduContact = (id) => {
  return apis.get(`${API_URLS.GET_COMPTE_RENDU_CONTACT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfCompteRenduContact = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_COMPTE_RENDU_CONTACT}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const genererPdfIsfCompteRenduContact = (id) => {
  return apis.get(`${API_URLS.GENERER_PDF_COMPTE_RENDU_CONTACT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateIsfCompteRenduContact = (id, payload) => {
  return apis.put(`${API_URLS.PUT_COMPTE_RENDU_CONTACT}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCompteRenduContact = (id) => {
  return apis.delete(`${API_URLS.DELETE_COMPTE_RENDU_CONTACT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postDecisionIsfCvgfr = (payload) => {
  return apis.post(API_URLS.POST_DECISION_ISF_CVGFR, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putDecisionIsfCvgfr = (id, payload) => {
  return apis.put(`${API_URLS.PUT_DECISION_ISF_CVGFR}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getDecisionIsfCvgfr = (id) => {
  return apis.get(`${API_URLS.GET_DECISION_ISF_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteDecisionIsfCvgfr = (id) => {
  return apis.delete(`${API_URLS.DELETE_DECISION_ISF_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const genererPdfDecisionIsfCvgfr = (id) => {
  return apis.get(`${API_URLS.GENERER_PDF_DECISION_ISF_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfDecisionIsfCvgfr = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_DECISION_ISF_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postPvConstitutionCvgfr = (payload) => {
  return apis.post(API_URLS.POST_PV_CONSTITUTION_CVGFR, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putPvConstitutionCvgfr = (id, payload) => {
  return apis.put(`${API_URLS.PUT_PV_CONSTITUTION_CVGFR}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getPvConstitutionCvgfr = (id) => {
  return apis.get(`${API_URLS.GET_PV_CONSTITUTION_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deletePvConstitutionCvgfr = (id) => {
  return apis.delete(`${API_URLS.DELETE_PV_CONSTITUTION_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const genererPdfPvConstitutionCvgfr = (id) => {
  return apis.get(`${API_URLS.GENERER_PDF_PV_CONSTITUTION_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfPvConstitutionCvgfr = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_PV_CONSTITUTION_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postLivrableIsfCvgfr = (payload) => {
  return apis.post(API_URLS.POST_LIVRABLE_ISF_CVGFR, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putLivrableIsfCvgfr = (id, payload) => {
  return apis.put(`${API_URLS.PUT_LIVRABLE_ISF_CVGFR}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteLivrableIsfCvgfr = (id) => {
  return apis.delete(`${API_URLS.DELETE_LIVRABLE_ISF_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfLivrableIsfCvgfr = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_LIVRABLE_ISF_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const genererPdfLivrableIsfCvgfr = (id) => {
  return apis.get(`${API_URLS.GENERER_PDF_LIVRABLE_ISF_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getLivrableIsfCvgfr = (id) => {
  return apis.get(`${API_URLS.GET_LIVRABLE_ISF_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getIsfCahiersIntentionsCF = (id) => {
  return apis.get(`${API_URLS.GET_CACHIERS_INTENTIONS_CF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addIsfCahiersIntentionsCF = (payload) => {
  return apis.post(API_URLS.POST_CACHIERS_INTENTIONS_CF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfCahiersIntentionsCF = (id, payload) => {
  return apis.put(`${API_URLS.PUT_CACHIERS_INTENTIONS_CF}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const genererPdfIsfRapportVillage = (id) => {
  return apis.get(`${API_URLS.GENERER_PDF_ISF_RAPPORT_VILLAGE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getIsfCahiersIntentionsContrat = (id) => {
  return apis.get(`${API_URLS.GET_CACHIERS_INTENTIONS_CONTRAT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addIsfCahiersIntentionsContrat = (payload) => {
  return apis.post(API_URLS.POST_CACHIERS_INTENTIONS_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfCahiersIntentionsContrat = (id, payload) => {
  return apis.put(`${API_URLS.PUT_CACHIERS_INTENTIONS_CONTRAT}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfIsfCahiersIntentionsCF = (id) => {
  return apis.delete(`${API_URLS.DELETE_CACHIERS_INTENTIONS_CF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteIsfIsfCahiersIntentionsContrat = (id) => {
  return apis.delete(`${API_URLS.DELETE_CACHIERS_INTENTIONS_CONTRAT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfCahiersIntentionsDCF = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_CACHIERS_INTENTIONS_CF}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadPdfIsfCahiersIntentionsDCC = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_CACHIERS_INTENTIONS_CONTRAT}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const addIsfDeclarationOuverture = (payload) => {
  return apis.post(API_URLS.POST_ISF_DECLARATION_OUVERTURE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfDeclarationOuverture = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ISF_DECLARATION_OUVERTURE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfDeclarationOuvertureture = (id) => {
  return apis.delete(`${API_URLS.DELETE_ISF_DECLARATION_OUVERTURE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfDeclarationOuvertureture = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_DECLARATION_OUVERTURE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getIsfDeclarationOuvertureture = (id) => {
  return apis.get(`${API_URLS.GET_ISFR_DECLARATION_OUVERTURE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addIsfCeremonieOuverture = (payload) => {
  return apis.post(API_URLS.POST_ISF_CEREMONIE_OUVERTURE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfCeremonieOuverture = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ISF_CEREMONIE_OUVERTURE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCeremonieOuvertureture = (id) => {
  return apis.delete(`${API_URLS.DELETE_ISF_CEREMONIE_OUVERTURE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfCeremonieOuvertureture = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_CEREMONIE_OUVERTURE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getIsfCeremonieOuvertureture = (id) => {
  return apis.get(`${API_URLS.GET_ISFR_CEREMONIE_OUVERTURE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addIsfCoCompteRendu = (payload) => {
  return apis.post(API_URLS.POST_ISF_COMPTE_RENDU, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfCoCompteRendu = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ISF_COMPTE_RENDU}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCoCompteRendu = (id) => {
  return apis.delete(`${API_URLS.DELETE_ISF_COMPTE_RENDU}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfCoCompteRendu = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_COMPTE_RENDU}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getIsfCoCompteRendu = (id) => {
  return apis.get(`${API_URLS.GET_ISF_COMPTE_RENDU}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postIsfRapportVillage = (payload) => {
  return apis.post(API_URLS.POST_ISF_RAPPORT_VILLAGE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfRapportVillage = (id) => {
  return apis.get(`${API_URLS.GET_ISF_RAPPORT_VILLAGE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const putIsfRapportVillage = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ISF_RAPPORT_VILLAGE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfRapportVillage = (id) => {
  return apis.delete(`${API_URLS.DELETE_ISF_RAPPORT_VILLAGE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfRapportVillage = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_RAPPORT_VILLAGE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postIsfCalendrierPrev = (payload) => {
  return apis.post(API_URLS.POST_ISF_CALENDRIER_PREV, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfCalendrierPrev = (id) => {
  return apis.get(`${API_URLS.GET_ISF_CALENDRIER_PREV}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const putIsfCalendrierPrev = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ISF_CALENDRIER_PREV}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCalendrierPrev = (id) => {
  return apis.delete(`${API_URLS.DELETE_ISF_CALENDRIER_PREV}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfCalendrierPrev = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_CALENDRIER_PREV}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postIsfCourrierTrans = (payload) => {
  return apis.post(API_URLS.POST_ISF_COURRIER_TRANS, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postIsfFermetureCeremonie = (payload) => {
  return apis.post(API_URLS.POST_ISF_FERMETURE_CEREMONIE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfCourrierTrans = (id) => {
  return apis.get(`${API_URLS.GET_ISF_COURRIER_TRANS}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const putIsfCourrierTrans = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ISF_COURRIER_TRANS}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCourrierTrans = (id) => {
  return apis.delete(`${API_URLS.DELETE_ISF_COURRIER_TRANS}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfCourrierTrans = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_COURRIER_TRANS}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};
// export const authUserWithToken = (token) => {
//   return apis.get(`${API_URLS.LOGIN_WITH_TOKEN}?token=${token}`, {
//     headers: { 'Content-Type': 'application/json' },
//   });
// };

// export const getUser = (id) => {
//   return apis.get(`${API_URLS.GET_USER}/${id}`, {
//     headers: { 'Content-Type': 'application/json', },
//   });
// };

export const getUser = (payload) => {
  return apis.post(`${API_URLS.GET_USER}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const authUserWithToken = async (token) => {
  return await apis.get(`${API_URLS.LOGIN_WITH_TOKEN}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getReglementInterieurCvgfr = (id) => {
  return apis.get(`${API_URLS.GET_REGLEMENT_INTERIEUR_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfReglementInterieurCvgfr = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_REGLEMENT_INTERIEUR_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const generatePdfReglementInterieurCvgfr = (payload) => {
  return apis.post(`${API_URLS.GENERER_PDF_REGLEMENT_INTERIEUR_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteReglementInterieurCvgfr = (id) => {
  return apis.delete(`${API_URLS.DELETE_REGLEMENT_INTERIEUR_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

//create & update
export const createReglementInterieurCvgfr = (payload) => {
  return apis.post(`${API_URLS.POST_REGLEMENT_INTERIEUR_CVGFR}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateReglementInterieurCvgfr = (id, payload) => {
  return apis.put(`${API_URLS.PUT_REGLEMENT_INTERIEUR_CVGFR}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getAttestationFormationCvgfr = (id) => {
  return apis.get(`${API_URLS.GET_ATTESTATION_FORMATION_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfAttestationFormationCvgfr = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ATTESTATION_FORMATION_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const generatePdfAttestationFormationCvgfr = (payload) => {
  return apis.post(`${API_URLS.GENERER_PDF_ATTESTATION_FORMATION_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteAttestationFormationCvgfr = (id) => {
  return apis.delete(`${API_URLS.DELETE_ATTESTATION_FORMATION_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const createAttestationFormationCvgfr = (payload) => {
  return apis.post(`${API_URLS.POST_ATTESTATION_FORMATION_CVGFR}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateAttestationFormationCvgfr = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ATTESTATION_FORMATION_CVGFR}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getListePresenceFormationCvgfr = (id) => {
  return apis.get(`${API_URLS.GET_LISTE_PRESENCE_FORMATION_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addListePresenceFormationCvgfr = (payload) => {
  return apis.post(`${API_URLS.POST_LISTE_PRESENCE_FORMATION_CVGFR}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateListePresenceFormationCvgfr = (id, payload) => {
  return apis.put(`${API_URLS.PUT_LISTE_PRESENCE_FORMATION_CVGFR}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteListePresenceFormationCvgfr = (id) => {
  return apis.delete(
    `${API_URLS.DELETE_LISTE_PRESENCE_FORMATION_CVGFR}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfIsfPresforListePresenceFormationCvgfr = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_LISTE_PRESENCE_FORMATION_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const generatePdfListePresenceFormationCvgfr = (payload) => {
  return apis.post(`${API_URLS.GENERER_PDF_LISTE_PRESENCE_FORMATION_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// export const getReunionPeriodiqueDecisionSousPrefectorale = (id) => {
//   return apis.get(`${API_URLS.GET_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE}/${id}`, {
//     headers: { 'Content-Type': 'application/json' },
//   });
// };

export const postReunionPeriodiqueDecisionSousPrefectorale = (payload) => {
  return apis.post(
    `${API_URLS.POST_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const putReunionPeriodiqueDecisionSousPrefectorale = (id, payload) => {
  return apis.put(
    `${API_URLS.PUT_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const deleteReunionPeriodiqueDecisionSousPrefectorale = (id) => {
  return apis.delete(
    `${API_URLS.DELETE_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfReunionPeriodiqueDecisionSousPrefectorale = (payload) => {
  return apis.post(
    `${API_URLS.UPLOAD_PDF_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const generatePdfReunionPeriodiqueDecisionSousPrefectorale = (
  payload
) => {
  return apis.post(
    `${API_URLS.GENERER_PDF_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getReunionPeriodique = (id) => {
  return apis.get(`${API_URLS.GET_REUNION_PERIODIQUE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postReunionPeriodiqueResume = (payload) => {
  return apis.post(`${API_URLS.POST_REUNION_PERIODIQUE_RESUME}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putReunionPeriodiqueResume = (id, payload) => {
  return apis.put(`${API_URLS.PUT_REUNION_PERIODIQUE_RESUME}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteReunionPeriodiqueResume = (id) => {
  return apis.delete(`${API_URLS.DELETE_REUNION_PERIODIQUE_RESUME}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfReunionPeriodiqueResume = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_REUNION_PERIODIQUE_RESUME}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const generatePdfReunionPeriodiqueResume = (payload) => {
  return apis.post(`${API_URLS.GENERER_PDF_REUNION_PERIODIQUE_RESUME}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPvcfidcp = (payload) => {
  return apis.post(`${API_URLS.POST_PVCFIDCP}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putPvcfidcp = (id, payload) => {
  return apis.put(`${API_URLS.PUT_PVCFIDCP}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPvcfidci = (payload) => {
  return apis.post(`${API_URLS.POST_PVCFIDCI}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putPvcfidci = (id, payload) => {
  return apis.put(`${API_URLS.PUT_PVCFIDCI}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPvcfidcc = (payload) => {
  return apis.post(`${API_URLS.POST_PVCFIDCC}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putPvcfidcc = (id, payload) => {
  return apis.put(`${API_URLS.PUT_PVCFIDCC}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvcfid = (id) => {
  return apis.delete(`${API_URLS.DELETE_PVCFIDC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deletePvcfidc = (id) => {
  return apis.delete(`${API_URLS.DELETE_PVCFIDC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const deletePvcfidci = (id) => {
  return apis.delete(`${API_URLS.DELETE_PVCFIDCI}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deletePvcfidcp = (id) => {
  return apis.delete(`${API_URLS.DELETE_PVCFIDCP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deletePvcfidcc = (id) => {
  return apis.delete(`${API_URLS.DELETE_PVCFIDCC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfPvcfid = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_PVCFIDC}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadPdfPvcfidcp = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_PVCFIDCP}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadPdfPvcfidcc = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_PVCFIDCC}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadPdfPvcfidci = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_PVCFIDCI}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadPdfPvcfidc = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_PVCFIDC}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getDialogueSocial = (id) => {
  return apis.get(`${API_URLS.GET_DIALOGUE_SOCIAL}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addCalendrierPrevisionnel = (payload) => {
  return apis.post(`${API_URLS.POST_CALENDRIER_PREVISIONEL}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateCalendrierPrevisionnel = (id, payload) => {
  return apis.put(`${API_URLS.PUT_CALENDRIER_PREVISIONEL}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getCalendrierPrevisionnel = (id) => {
  return apis.get(`${API_URLS.GET_CALENDRIER_PREVISIONEL}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteCalendrierPrevisionnel = (id) => {
  return apis.delete(`${API_URLS.DELETE_CALENDRIER_PREVSIONNEL}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadCalendrierPrevisionnel = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_CALENDRIER_PREVISIONNEL}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getPvrlf = (id) => {
  return apis.get(`${API_URLS.GET_PROCES_VERBAL_REGLEMENT_LITIGE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deletePvrlf = (id) => {
  return apis.delete(
    `${API_URLS.DELETE_PROCES_VERBAL_REGLEMENT_LITIGE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addPvrl = (payload) => {
  return apis.post(`${API_URLS.POST_PROCES_VERBAL_REGLEMENT_LITIGE}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updatePvrlf = (id, payload) => {
  return apis.put(`${API_URLS.PUT_PROCES_VERBAL_REGLEMENT_LITIGE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const uploadPdfIsfPresforPvrlf = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_PROCES_VERBAL_REGLEMENT_LITIGE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const addIsfDemandeIdentite = (payload) => {
  return apis.post(`${API_URLS.POST_ISF_DEMANDE_IDENTITE}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfDemandeIdentite = (id) => {
  return apis.get(`${API_URLS.GET_ISF_DEMANDE_IDENTITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateIsfDemandeIdentite = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ISF_DEMANDE_IDENTITE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfDemandeIdentite = (id) => {
  return apis.delete(`${API_URLS.DELETE_ISF_DEMANDE_IDENTITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfDemandeIdentite = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_DEMANDE_IDENTITE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const addProcesVerbalConstatAchevement = (payload) => {
  return apis.post(`${API_URLS.POST_ISF_PROCES_VERBAL_ACHEVEMENT}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getProcesVerbalConstatAchevement = (id) => {
  return apis.get(`${API_URLS.GET_PROCES_VERBAL_ACHEVEMENT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateProcesVerbalConstatAchevement = (id, payload) => {
  return apis.put(`${API_URLS.PUT_PROCES_VERBAL_ACHEVEMENT}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteProcesVerbalConstatAchevement = (id) => {
  return apis.delete(`${API_URLS.DELETE_PROCES_VERBAL_ACHEVEMENT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfProcesVerbalConstatAchevement = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_PROCES_VERBAL_ACHEVEMENT}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};
// Ajouter une charte relation tuteur-planteur
export const addCharteRelationTuteurPlanteur = (payload) => {
  return apis.post(`${API_URLS.POST_CHARTERELATION}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// Récupérer une charte par ID
export const getCharteRelationTuteurPlanteur = (id) => {
  return apis.get(`${API_URLS.GET_CHARTERELATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Mettre à jour une charte relation tuteur-planteur
export const updateCharteRelationTuteurPlanteur = (id, payload) => {
  return apis.put(`${API_URLS.PUT_CHARTERELATION}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// Supprimer une charte relation tuteur-planteur
export const deleteCharteRelationTuteurPlanteur = (id) => {
  return apis.delete(`${API_URLS.DELETE_CHARTERELATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Upload PDF pour une charte relation tuteur-planteur
export const uploadPdfCharteRelationTuteurPlanteur = (payload) => {
  return apis.post(`${API_URLS.UPLOADS_CHARTE_PDF}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

// Ajouter un protocole de gestion foncière
export const addProtocoleGestionFonciere = (payload) => {
  return apis.post(`${API_URLS.POST_NEW_PGF}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// Récupérer un protocole par numéro d'enquête
export const getProtocoleGestionFonciere = (numero_enquete) => {
  return apis.get(`${API_URLS.GET_PGF_BY_NUMERO}/${numero_enquete}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Mettre à jour un protocole de gestion foncière
export const updateProtocoleGestionFonciere = (id, payload) => {
  return apis.put(`${API_URLS.PUT_UPDATE_PGF}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// Supprimer un protocole de gestion foncière
export const deleteProtocoleGestionFonciere = (id) => {
  return apis.delete(`${API_URLS.DELETE_PGF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Upload PDF pour un protocole de gestion foncière
export const uploadPdfProtocoleGestionFonciere = (payload) => {
  return apis.post(`${API_URLS.POST_UPLOAD_PGF_PDF}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const addIsfRapportActivite = (payload) => {
  return apis.post(`${API_URLS.POST_ISF_RAPPORT_ACTIVITE}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfRapportActivite = (id) => {
  return apis.get(`${API_URLS.GET_ISF_RAPPORT_ACTIVITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addGuideEntretien = (payload) => {
  return apis.post(`${API_URLS.POST_ISF_GUIDE_ENTRETIEN}`, payload, {
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getGuideEntretien = (id) => {
  return apis.get(`${API_URLS.GET_GUIDE_ENTRETIEN}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateGuideEntretien = (id, payload) => {
  return apis.put(`${API_URLS.PUT_GUIDE_ENTRETIEN}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteGuideEntretien = (id) => {
  return apis.delete(`${API_URLS.DELETE_GUIDE_ENTRETIEN}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadGuideEntretien = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_GUIDE_ENTRETIEN}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const addRapportIsfSensibilisation = (payload) => {
  return apis.post(
    `${API_URLS.POST_ISF_RAPPORT_SENSIBILISATION_ISF}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getRapportIsfSensibilisation = (id) => {
  return apis.get(`${API_URLS.GET_RAPPORT_SENSIBILISATION_ISF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateRapportIsfSensibilisation = (id, payload) => {
  return apis.put(`${API_URLS.PUT_RAPPORT_SENSIBILISATION_ISF}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteRapportIsfSensibilisation = (id) => {
  return apis.delete(`${API_URLS.DELETE_RAPPORT_SENSIBILISATION_ISF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadRapportIsfSensibilisation = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_RAPPORT_SENSIBILISATION_ISF}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};
export const getIsfSensibilisation = (id) => {
  return apis.get(`${API_URLS.GET_ISF_SENSIBILISATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addIsfSensibilisation = (payload) => {
  return apis.post(`${API_URLS.POST_ISF_SENSIBILISATION}`, payload, {
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfSensibilisation = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ISF_SENSIBILISATION}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfSensibilisation = (id) => {
  return apis.delete(`${API_URLS.DELETE_ISF_SENSIBILISATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadIsfSensibilisation = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_SENSIBILISATION}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updateIsfRapportActivite = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ISF_RAPPORT_ACTIVITE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfRapportActivite = (id) => {
  return apis.delete(`${API_URLS.DELETE_ISF_RAPPORT_ACTIVITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfRapportActivite = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_RAPPORT_ACTIVITE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getIsfRecueilPersonnelles = (id) => {
  return apis.get(`${API_URLS.GET_ISF_RECUEIL_DONNEES_PERSONNELLES}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addIsfRecueilPersonnelles = (payload) => {
  return apis.post(
    `${API_URLS.POST_ISF_RECUEIL_DONNEES_PERSONNELLES}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const updateIsfRecueilPersonnelles = (id, payload) => {
  return apis.put(`${API_URLS.PUT_ISF_RECUEIL_DONNEES_PERSONNELLES}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfRecueilPersonnelles = (id) => {
  return apis.delete(
    `${API_URLS.DELETE_ISF_RECUEIL_DONNEES_PERSONNELLES}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadIsfRecueilPersonnelles = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_RECUEIL_DONNEES_PERSONNELLES}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getAllPrefecture = (payload) => {
  return apis.get(`${API_URLS.GET_ALL_PREFECTURE}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getIsfCalendrierOuvertureByCodeSp = (code_sp) => {
  return apis.get(
    `${API_URLS.GET_CALENDRIER_OUVERTURE_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getIsfRecueilPersonnellesByCodeSp = (code_sp) => {
  return apis.get(
    `${API_URLS.GET_RECUEIL_DONNEES_PERSONNELLES_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getIsfCeremonieOuverturetureByCodeSp = (code_sp) => {
  return apis.get(
    `${API_URLS.GET_ISF_CEREMONIE_OUVERTURE_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getIsfDeclarationOuvertureByCodeSp = (code_sp) => {
  return apis.get(
    `${API_URLS.GET_ISF_DECLARATION_OUVERTURE_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const updateIsfDeclarationOuvertureSp = (payload) => {
  return apis.post(`${API_URLS.PUT_ISF_DECLARATION_OUVERTURE_SP}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getDtvRapportActivites = (id) => {
  return apis.get(`${API_URLS.GET_DTV_RAPPORT_ACTIVITES}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};


export const addDtvRapportActivites = (payload) => {
  return apis.post(`${API_URLS.POST_DTV_RAPPORT_ACTIVITES}`, payload, {
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateDtvRapportActivites = (id, payload) => {
  return apis.put(`${API_URLS.PUT_DTV_RAPPORT_ACTIVITES}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteDtvRapportActivites = (id) => {
  return apis.delete(`${API_URLS.DELETE_DTV_RAPPORT_ACTIVITES}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteDtvAllRapportActivites = (numero_enquete) => {
  return apis.delete(
    `${API_URLS.DELETE_DTV_ALL_RAPPORT_ACTIVITES}/${numero_enquete}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadDtvRapportActivites = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_DTV_RAPPORT_ACTIVITES}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const deleteIsfDeclarationOuverturetureBySp = (code_sp) => {
  return apis.delete(
    `${API_URLS.DELETE_ISF_DECLARATION_OUVERTURE_BY_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addIsfDeclarationOuvertureSp = (payload) => {
  return apis.post(`${API_URLS.POST_ISF_DECLARATION_OUVERTURE_SP}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getLivrableIsfCvgfrByCodeSp = (code_sp) => {
  return apis.get(`${API_URLS.GET_LIVRABLE_ISF_CVGFR_BY_CODE_SP}/${code_sp}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postReunionPeriodiqueDecisionSousPrefectoraleSp = (payload) => {
  return apis.post(
    `${API_URLS.POST_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getReunionPeriodiqueDecisionSousPrefectoraleSp = (code_sp) => {
  return apis.get(
    `${API_URLS.GET_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getIsfCourrierTransByCodeSp = (code_sp) => {
  return apis.get(
    `${API_URLS.GET_ISF_COURRIER_TRANSMISSION_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getReunionPeriodiqueByCodeSp = (code_sp) => {
  return apis.get(
    `${API_URLS.GET_ISF_REUNION_PERIODIQUE_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const updateIsfCourrierTransByCodeSp = (payload) => {
  return apis.post(`${API_URLS.PUT_ISF_COURRIER_TRANSMISSION_BY_CODE_SP}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCourrierTransByCodeSp = (code_sp) => {
  return apis.delete(
    `${API_URLS.DELETE_ISF_COURRIER_TRANSMISSION_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const putReunionPeriodiqueDecisionSousPrefectoraleSp = (id, payload) => {
  return apis.put(
    `${API_URLS.PUT_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const deleteReunionPeriodiqueDecisionSousPrefectoraleSp = (code_sp) => {
  return apis.delete(
    `${API_URLS.DELETE_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfReunionPeriodiqueDecisionSousPrefectoraleSp = (
  payload
) => {
  return apis.post(
    `${API_URLS.UPLOAD_PDF_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const addReunionPeriodiqueByCodeSp = (payload) => {
  return apis.post(`${API_URLS.POST_ISF_REUNION_PERIODIQUE_SP}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateReunionPeriodiqueByCodeSp = (payload) => {
  return apis.post(`${API_URLS.UPDATE_ISF_REUNION_PERIODIQUE_SP}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteReunionPeriodiqueByCodeSp = (code_sp) => {
  return apis.delete(
    `${API_URLS.DELETE_ISF_REUNION_PERIODIQUE_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfReunionPeriodiqueSp = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_REUNION_PERIODIQUE_SP}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadPdfIsfDeclarationOuverturetureSp = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_DECLARATION_OUVERTURE_SP}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getEnqueteByCodeSp = (code_sp) => {
  return apis.get(`${API_URLS.GET_ENQUETE_BY_CODE_SP}/${code_sp}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postPVCLWithDcf = (payload) => {
  return apis.post(`${API_URLS.POST_PVCL_WITH_DCF}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfComplementaireInformationSensibilisation = (id) => {
  return apis.get(
    `${API_URLS.GET_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const deleteIsfComplementaireInformationSensibilisation = (id) => {
  return apis.delete(
    `${API_URLS.DELETE_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addIsfComplementaireInformationSensibilisation = (payload) => {
  return apis.post(
    `${API_URLS.POST_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const updateIsfComplementaireInformationSensibilisation = (
  id,
  payload
) => {
  return apis.put(
    `${API_URLS.UPDATE_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const uploadPdfIsfComplementaireInformationSensibilisation = (
  payload
) => {
  return apis.post(
    `${API_URLS.UPLOAD_PDF_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};



export const getIsfComplementaireFacilitation = (id) => {
  return apis.get(
    `${API_URLS.GET_ISF_COMPLEMENTAIRE_FACILITATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const deleteIsfComplementaireFacilitation = (id) => {
  return apis.delete(
    `${API_URLS.DELETE_ISF_COMPLEMENTAIRE_FACILITATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addIsfComplementaireFacilitation = (payload) => {
  return apis.post(
    `${API_URLS.POST_ISF_COMPLEMENTAIRE_FACILITATION}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const updateIsfComplementaireFacilitation = (
  id,
  payload
) => {
  return apis.put(
    `${API_URLS.UPDATE_ISF_COMPLEMENTAIRE_FACILITATION}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const uploadPdfIsfComplementaireFacilitation = (
  payload
) => {
  return apis.post(
    `${API_URLS.UPLOAD_PDF_ISF_COMPLEMENTAIRE_FACILITATION}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const getIsfComplementaireFormationEncadrement = (id) => {
  return apis.get(`${API_URLS.GET_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
}

export const deleteIsfComplementaireFormationEncadrement = (id) => {
  return apis.delete(`${API_URLS.DELETE_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT}/${id}`, {
    headers: { 'Content-Type': 'application/json' }
  });
}

export const addIsfComplementaireFormationEncadrement = (payload) => {
  return apis.post(`${API_URLS.POST_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
}

export const updateIsfComplementaireFormationEncadrement = (id, payload) => {
  return apis.put(`${API_URLS.UPDATE_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
}

export const uploadPdfIsfComplementaireFormationEncadrement = (payload) => {
  return apis.post(`${API_URLS.UPLOAD_PDF_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
}

export const getDtvScanDocument = (id) => {
  return apis.get(`${API_URLS.GET_DTV_SCAN_DOCUMENT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteDtvScanDocument = (id) => {
  return apis.delete(`${API_URLS.DELETE_DTV_SCAN_DOCUMENT}/${id}`, {
    headers: { 'Content-Type': 'application/json' }
  });
}

export const deleteDtvAllScanDocument = (numero_enquete) => {
  return apis.delete(`${API_URLS.DELETE_DTV_ALL_SCAN_DOCUMENT}/${numero_enquete}`, {
    headers: { 'Content-Type': 'application/json' }
  });
}

export const addDtvScanDocument = (payload) => {
  return apis.post(`${API_URLS.POST_DTV_SCAN_DOCUMENT}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
}

export const updateDtvScanDocument = (id, payload) => {
  return apis.put(`${API_URLS.UPDATE_DTV_SCAN_DOCUMENT}/${id}`, {
   ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
}
